var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "birth_2",
    "data-name": "birth 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 10 326.09 69.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .birth-1 {\n        fill: #ee3337;\n        font-family: RedSoxNationNormal, RedSoxNation;\n        font-size: 52.65px;\n      }\n\n      .birth-2 {\n        fill: #f0e2cb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "birth_1",
    "data-name": "birth 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "birth-1",
    transform: "translate(0 66.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "The Birth of a")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.61,11.5c-.03-.05-.16.11-.19.13.11.03.23-.17.19-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "164.67 11.82 164.6 11.87 164.84 11.81 164.67 11.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.34,12.43c.17-.33-.28-.18-.32-.38l.03-.08-.25.16c.18.1.49.13.53.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.21,13.34c.07-.13.16-.02-.06-.11,0,.02,0,.03,0,.04.02.01.04.03.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.15,13.27c-.08-.05-.03.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.55,13.49l-.18.02c-.03.08.05.17-.02.19.15.03.18-.05.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.81,13.36h-.08s0,.05.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.54,13.36h.18c.02-.05.09-.14-.08,0,.08-.07,0-.01-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.51,13.27c0-.1-.05-.2.13-.21-.22-.11-.35.1-.13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.61,12.18v-.14s-.14.04-.14.04c.07-.02.07.2.14.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.06,14.14c.05-.05.09-.19.14-.27h-.13c0,.08.05.18-.02.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.2,13.87h.19c-.09-.11-.14-.07-.19,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "166.07 13.07 165.72 13.14 166.11 13.1 166.07 13.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "166.47 14.49 166.3 14.57 166.58 14.45 166.47 14.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.78,14.67c-.14.08-.08.25-.19.28.1.04.24-.01.36-.06-.1,0-.16-.06-.18-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.16,14.83c-.05,0-.12.03-.2.06.05,0,.12-.02.2-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.55,14.03s-.08.15-.04.24l.09-.2-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.6,14.06h0s.07.08.09.09c-.01-.01-.04-.04-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.54,14.02h.01s.01-.02-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.24,13.45c.14-.04.35-.04.34-.28-.14.08-.13.22-.34.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.65,13.77l-.09-.13s-.06.13-.13.15l.22-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "166.75 13.76 166.65 13.77 166.69 13.82 166.75 13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.07,14.52c.11-.04.17,0,.24.03-.04-.08-.1-.15-.17-.2-.05.05-.15.12-.07.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.85,14.29h.02s0-.03-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "167.95 15.01 167.96 14.97 167.93 15 167.95 15.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.16,14.31c-.03-.07-.09-.05-.16-.02.05.01.1.03.15.06.02-.02.04-.04.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.4,14.88c0-.06,0-.11-.02-.16-.01.07-.02.2.02.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.85,14.35h-.01c-.01.05,0,.03.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.85,14.35s.1-.03.15-.05c-.04,0-.08-.01-.13,0,0,.02,0,.04-.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M168.92,14.03c-.12.16-.36.21-.35-.05-.2.04-.5.62-.61.99.05-.07.1-.13.29-.14.02-.12-.12-.4.09-.47.21.03.09.15.1.29.08-.25.4-.15.58-.47h-.21s.13-.08.12-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.74,14.79l-.06-.02c.04.07.03.16.01.34.14-.02.2-.07.24-.12l-.23-.2h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.46,14.62c.17-.15.34-.14.4-.38-.15-.09-.21.07-.35.09.26.12-.14.05-.04.27-.07,0-.11-.02-.16-.04.03.05.05.11.06.17h0s0-.01,0-.01h0s.01-.05.01-.03h0s.04-.04.06-.06c.04.08-.02.05-.06.06l-.02.02h0s.3.08.3.08c-.03-.06-.1-.1-.22-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.98,12.9s-.01.03-.02.04c.03,0,.05-.02.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.99,13.08s-.1.07-.14,0c0-.09.06-.08.11-.14-.07.02-.21.03-.17.19h.03c.04.12,0,.42-.04.43.09-.17.15-.3.21-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.25,13.81l.25.05v-.22s-.05.09-.05.09c-.08-.11-.14.01-.21.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "167.91 15.12 167.75 15.28 168.05 15.1 167.91 15.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "168.17 15.28 168.05 15.43 168.19 15.38 168.17 15.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.29,21.62h.09s-.06-.01-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.86,21.37l-.06.08s.07-.07.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M174.63,19.18c0,.21-.04.52.06.31l.08-.21c-.08,0-.12-.05-.13-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.73,20.45v-.07c-.05.05-.1.1-.15.15.05-.02.1-.05.15-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.22,19.69l.05.18c0-.06-.02-.12-.05-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.78,22.81l.18-.15c-.11-.07-.12.06-.18.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M170.87,16.94c.03.12.07.18.12.22-.03-.16,0-.36-.12-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.99,23.54c.06-.01.09-.04.12-.09-.06.01-.1.04-.12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M171.2,17.29s0-.04-.01-.07c-.07,0-.14-.01-.2-.06.02.12.06.21.22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.61,28.99s0,.02,0,.03c.02-.02.01-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.69,32.41s-.08-.03-.12-.05c.01.02.05.04.12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.16,16.05c-.06-.02-.02.01,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.37,15.16s.05-.03.08-.07c-.03.04-.06.06-.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M172.45,16.47h0s0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.13,15.91s.02.07.03.1c0-.02-.01-.05-.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.08,16.01s-.03-.03-.04-.05c-.03.03-.03.05.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.24,16.09s-.06-.05-.08-.08c0,.02,0,.03,0,.04.02,0,.04.02.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.21,26.03s0,.01,0,.02c.11-.03.08-.04,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "177.17 18 177.16 18.01 177.17 18.02 177.17 18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M177.45,17.97c-.21.19-.25.14-.29.05l-.23.59.51-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.36,22.17l-.04-.25c.33-.18.4-.01.41-.33-.36.58-.59-.26-.95.32l-.02-.18s.05-.01.07.01c-.02-.39-.38.35-.56.13-.06-.09-.06-.21.03-.25l-.27.05s.02-.14.07-.1l-.31-.11v-.02c-.08.07-.25.17-.33.2-.02-.12.07-.04.09-.13l-.23.06c.02-.19.23-.27.33-.19.18-.67-.21.08-.33-.44h.19c.09-.38-.09-.32-.14-.63-.02.13.04.71-.21.77-.02-.07-.07-.13-.23-.06.12-.21,0-.21-.12-.26l.16-.28c-.16.02-.23.16-.37.25-.12-.1-.03-.33.04-.53-.19-.16-.04.43-.32.35-.12-.2-.31-.15-.61-.1-.07-.16.11-.16.11-.27l-.23.17s.02-.08.04-.12c-.14.04-.16.28-.35.28-.21.29-.06-.61-.43-.36,0-.1.11-.16.16-.28-.37.1-.3.05-.67.26l-.07-.28c.01.28-.28.44-.53.58,0,.13-.02.24-.02.29l-.31.03c0-.06.07-.15.17-.24-.03.02-.05.03-.08.05-.03-.15.1-.29.25-.42,0,.07,0,.14-.01.22.15-.14.3-.3.38-.48-.03.02-.08.04-.12.04.04-.04.07-.08.08-.11,0-.03-.05.02-.12.07l.12-.34-.08.12-.19-.35c-.38.2-.81.57-1.22.52.21-.19.22-.37.37-.64-.06.34.33.02.47.17-.08-.08.01-.2.06-.23l-.45.1c.13-.22.02-.2,0-.34-.17.48-.39.17-.59.24.07-.15.18-.29.32-.17,0-.42-.5.4-.51.03.04.02.05.05.1-.02-.16.08-.32-.13-.2-.24l.04.02c-.22-.19-.76-.41-1-.06.02-.05.27-.43.33-.5l-1.12,1.02c.21-.3.47-1.15.78-1.22-.04-.08-.08-.17-.27-.12.02.07-.15.52-.22.52.04-.44,0-.25-.02-.66.02.1-.32.57-.4.5.06-.07.26-.5.32-.53l-.51.36c.11-.06.24-.41.26-.58-.03.11-.2-.12-.29-.11l.04.17c-.23-.22-.65.55-.9.38.09-.08.42-.58.32-.72-.2.22-.95,1.06-1.29,1.12l.03-.17-.27.06c.32-.31,1.09-.94,1.43-1.15-.04-.17.07-.18-.09-.25.02-.16.2-.16.24-.14l-.3-.28c-.15.3-.43.14-.55.4l.55-.09c-.15.3-.68.71-.9.52,0-.15.34-.49.39-.6-.09.08-.34.06-.32-.02l.19-.1c-.07-.19-.44.26-.45-.11-.05-.05.05-.47-.06-.3-.1.39-.67,1.43-.88,1.64,0-.03-.12-.49-.09-.69.06-.31.5-.54.55-.81-.05.08-.16.15-.2.17-.02-.1.17-.23.02-.27-.19.28-.25-.18-.21.21-.18.01-.1-.14-.26-.21-.06.22-.51.57-.69.57.05-.07.08-.18.09-.24-.24-.18-.3-.4-.54-.55.02-.08-.04-.24.08-.33-.07.03-.16.11-.24.07.01-.34.19.06.26-.31-.11.16-.33.12-.5.16-.13.28.21.2.38.16-.22.36-.63.63-.99.64-.26-.03.06-.28,0-.25-.34-.29-.71.42-.86-.03.02-.31.28-.45.36-.63.21.02.15.3.27.37l-.06-.19c.1-.04.24-.03.26.07.03-.27-.59-.44-.75-.82-.1.04-.24.06-.26.18l.11.03c-.04.24-.33.14-.28.3-.2.05-.47.16-.58-.06l.14-.28c-.05.08,0,.22.11.18-.15.07-.03-.51-.33-.23v.25c-.21.05-.55.22-.64.03-.1.3.05,0-.04.36.16-.43.38.27.49-.21-.12.41.09.27.04.66.05-.09.06-.19.16-.07.02-.02.06-.04.08-.06,0,0,0,0,0,.01h0s.02-.03,0-.02c0-.06,0-.12.02-.17.19-.15.39-.01.52-.07.05.09-.1.08-.11.19l.2-.08c-.11.19,0,.45-.25.44l.16.11c.03.17.13.3.26.27.05.09.33-.08.17.02l.33.04-.03.05c.24.18.72,0,.8.52.12,0,.24,0,.35.14l-.07.18c.14,0,.23.37.38.22-.15.53.48.41.63.6l.13-.22c.13.09.29.1.51.11l.1-.2c.23-.08.29.35.53.46-.06.07-.1.01-.12-.06.02.6.75,0,.82.46.1-.04.13.01.15.08,0,0-.01,0-.02,0,0,0,.01.01.02.02,0,.05.01.1.03.15,0-.06,0-.11-.01-.14.05.02.14.04.23.03l-.09.23s.01,0,.02,0c.03.12.11-.07.16-.25.05-.02.11-.04.16-.08-.13.37.25-.01.13.39.14-.15.43.06.67-.29-.02.05-.02.08-.06.07.06.09.11.17.24.1l-.11.29.37-.27c.02.22,0,.34-.21.49.42-.18.27-.01.65-.21l-.1.17c.08.03.33-.13.3.03,0,.42.82.5,1.09,1.04.19-.56.08.34.31-.05-.04.14-.01.24-.14.3.29,0,.23.37.57.12-.04.14-.14.15-.16.24.03-.02.13-.07.11.02-.02.08-.09.08-.15.12.24.1.46-.26.66-.61.03.23.1.24.3.05-.02.14-.02.29-.18.26.07.06.4.43.55.15-.01.08.1.08.14.06.17.11.17.15.36.21l-.02-.07c.25-.3.19,0,.35.04l-.02.03c.19.42.2-.04.37.41l.1-.22c.27-.44.14.42.42.34v-.16c.18-.1-.06.77.01.88,0,.05-.07.04-.12.06.12.41.18-.26.42-.21-.04.17-.25.35-.14.45,0,.16.65-.27.67.11.02-.14.05-.27.19-.31.16.04.14.64.46.35,0,.04,0,.07-.02.1.16-.04.43.04.6-.12-.31.78.86.03.47.69l.34.15-.05.06c.18.16.35.05.51-.07.02.07-.05.11-.07.15.22.31.26.3.71.13l-.1.23c.14-.08.22.59.67.53-.02.02-.05.06-.09.07.49-.05.4,1.06,1.01.38l.33-.05c-.23-.24.26-.3.23-.5.14.03.13.41-.03.36v-.05c-.3.36.25.37.06.63.56.33.91.91,1.37,1.28l.16-.33.16.14c0,.1-.11.27-.22.17-.06.21.3,0,.36-.05.14.29-.35.27-.28.33l.11.05v-.05c.17-.06.28-.18.41-.06.05.13-.09.21-.06.25-.02.02-.01.04.05.05l.18.19.1-.29c.18-.04.18.17.29-.16-.18.51.64.77.62.96.26-.05.38.05.52.2,0-.08.2-.34.3-.19-.49.46.04.43-.17.88.12-.32.43.28.58-.19.07.14-.16.19-.18.38.43.04.47.65.87.87.06-.06.09-.21.25-.25l-.11.49c.1.02.39-.34.32,0,.03-.07.08-.18.14-.16.42.9,1.59.81,1.99,1.96-.03-.21.06-.18.14-.14-.03-.07.11-.19.16-.3.06.16.12.32.18.48.21-.26.39.17.56-.1h-.14c.3-.27.16-.84.4-1.26-.35.3-.07-.74-.59-.35,0-.11.12-.11.15-.22-.16.14-.25.14-.33-.02l.04-.03c-.38-.18-.41-.45-.71-.84l-.11.21c-.06-.09-.03-.16-.04-.23-.31.22.22.19-.11.44.18-.46-.57-.45-.3-.94-.12-.1-.14.24-.26.14l.06-.14-.15.12c-.06-.09.02-.27.1-.37,0,.03.08.02.1.03.01-.22-.33-.2-.33-.27l.06.17c-.42-.18-.69-.68-1.22-.75l-.05.1c-.38-.07-.11-.27-.45-.44h.03c-.13.02-.24,0-.31-.08.16-.04.04-.31.23-.33-.43-.07-.26.01-.72.17l.08-.18c-.17.07-.24.14-.41.05.22-.02.09-.29.36-.34-.04-.56-.71-.06-.47-.63-.46.28.08.44-.07.46-.04.18-.36.2-.42.08-.09-.09.25-.65,0-.84.02.02.05,0,.07.01-.01-.17-.29,0-.28-.25-.25.2-.14-.13-.4.18l.29.1c-.19-.02-.6.26-.67-.07.06-.05.19-.09.27-.1,0-.14-.17-.03-.16-.17.26-.3.33.14.66,0,.03-.18-.44.03-.11-.26-.43.36-.21-.24-.63-.03l.15-.18s-.17.06-.22.02l.27-.18c-.29.11-.14-.39-.35-.37.29.2-.1.28-.09.51-.53,0,.17-.66-.3-.84.07,0,.12.25-.03.29-.05-.09-.1-.23-.07-.37-.29-.14-.1.23-.29.27.07-.3-.2.01-.36.01l.13-.2c-.21-.33-.36.36-.52.03l.3-.2-.19-.02.18-.21c-.27.07-.28,0-.39-.17-.06.17-.26.35-.39.27-.01-.18.17-.16-.03-.26.12-.1.27-.23.23.01.05-.06.12-.1.18-.16,0-.2-.23-.2-.3-.24.02.02.05.05.04.09l-.46.11c0-.1.08-.14.15-.18-.07-.01-.17.06-.26.02.13-.15.23-.33.4-.33l-.38.02c.03-.08-.01-.28.06-.32-.09-.19-.56.1-.68-.15-.03.03-.07.04-.12.04-.16-.15-.2-.46-.56-.36l.05-.37c-.21-.03-.06.48-.41.43-.26-.02.08-.3.05-.43-.19.09-.55.31-.59-.05.09-.02.12.05.19.06ZM183.16,21.1c.07-.02.22-.11.19.03-.18.22-.15.08-.19-.03ZM179.64,19.87c.07-.05.1,0,.11.12-.05,0-.09-.03-.11-.12ZM169.86,16.28s0,0,.01,0c.04.14.03.09-.01,0ZM169.74,16.07s-.05.04-.06.08c.05-.04.09-.02.13.03.02-.06.02-.11-.06-.1ZM189.77,27.72v-.07c.12,0,.06.03,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.16,19.78s-.03.08-.04.12c.04-.03.06-.07.04-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "186.74 22.84 186.75 22.84 186.78 22.81 186.74 22.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M173.67,16.08c.02.05.02.1.01.15.03-.05.04-.1-.01-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M168.53,15.77l.15.03c-.06-.03-.06-.09-.06-.14-.03.05-.05.13-.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M168.38,13.84s-.04-.02-.07-.01l-.06.09c.07.04.18,0,.13-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M168.87,15.03c.11-.17,0-.16-.11-.19,0,0,.01,0,.01.01-.19.22-.05.2.09.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M168.74,14.83s-.06-.02-.08-.05c-.07.09.02.04.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.43,16.03c-.01-.07-.17.2-.14.12-.19.19.43-.09.14-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "169.18 14.44 169.07 14.66 169.23 14.53 169.18 14.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.72,15.01l-.09-.14s-.05.05-.08.05c.08.06.14.16.17.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.54,14.92s-.08-.05-.13-.03c.02.01.08.04.13.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "169.4 14.49 169.41 14.56 169.49 14.64 169.4 14.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M171.1,15.96l.18.03c.06-.06.05-.13-.02-.14-.07.03-.14.03-.16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M171.03,15.11c.01.07-.02.12-.04.2l.17-.26-.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M171.49,15.31c.06-.06.34-.08.15-.18-.06.06-.24.04-.15.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "173.47 16.95 173.43 16.93 173.18 17.37 173.47 16.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M176.02,16.98c-.12-.2-.19.25-.28.03-.1.08.07.18-.02.25.17-.05.19.04.3-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M175.72,17.26s-.06.02-.09.04c.05-.01.07-.02.09-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "196.03 32.9 196.12 33.06 196.11 32.86 196.03 32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.45,32.67l-.1.31.2-.23s-.1,0-.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.15,20.36l-.05.06c-.02.08,0,.1.05.15v-.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "184.59 21.43 184.57 21.41 184.47 21.69 184.59 21.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.08,21.85s-.14-.02-.19-.06c.14.02.02.39.19.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M201.91,24.97s.15-.12.18-.14c-.08-.01-.22.18-.18.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "201.15 24.89 201.22 24.83 201.01 24.92 201.15 24.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.76,24.49c-.22.29.18.1.16.26l-.05.07.24-.17c-.12-.05-.36-.03-.35-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M201.1,23.73c-.09.11-.13.04.02.08,0-.01.01-.02.02-.03,0,0-.02-.02-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M201.13,23.78s.06-.11,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.89,23.64l.14-.03c.05-.07.01-.13.07-.15-.1,0-.15.06-.22.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.65,23.77h.07s.02-.05-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.85,23.75l-.14.02s-.11.13.06,0c-.08.07,0,.01.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.85,23.82c-.02.09-.02.16-.16.19.14.07.3-.12.16-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.47,24.72l-.03.11.12-.05c-.06.02-.01-.15-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.68,23.17c-.06.05-.13.16-.19.23l.1-.02c.02-.06.01-.13.09-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.49,23.4l-.15.03c.04.07.1.03.15-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "200.36 24.04 200.65 23.95 200.33 24.02 200.36 24.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "200.46 22.93 200.62 22.84 200.37 22.96 200.46 22.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.29,22.79c.13-.08.14-.21.23-.24-.06-.02-.18.03-.3.07.08,0,.1.04.06.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.05,22.68s.1-.03.17-.06c-.04,0-.09.02-.17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.26,23.3s.1-.13.11-.2l-.13.17.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.24,23.28h0s-.04-.06-.04-.07c0,0,.02.03.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.27,23.31h0s-.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.34,23.74c-.12.05-.29.06-.34.26.13-.08.16-.19.34-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.1,23.52l.03.1s.09-.11.15-.13l-.17.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "200.02 23.54 200.1 23.52 200.09 23.49 200.02 23.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.02,22.94c-.09.04-.13.01-.17-.01,0,.07.03.12.06.16.05-.04.15-.11.11-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.11,23.11h-.02s-.01.03.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "199.51 22.58 199.49 22.61 199.52 22.59 199.51 22.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.88,23.11c0,.06.05.04.11,0-.04,0-.07-.02-.09-.04-.02.02-.04.03-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.89,22.66s-.03.09-.04.13c.03-.06.08-.16.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.13,23.07h.01s0-.03-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.13,23.07s-.08.03-.13.05c.03,0,.06,0,.1,0,0-.01.02-.03.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.43,23.43c.15-.13.35-.19.26.03.17-.04.6-.53.81-.84-.06.06-.12.11-.27.13-.06.1-.04.32-.22.39-.16-.02-.02-.12.02-.23-.14.21-.36.14-.61.41h.16s-.13.06-.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.59,22.75h.04s.03-.12.1-.27c-.11.02-.17.06-.22.11l.11.15h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.75,22.88c-.17.13-.3.13-.43.33.09.07.18-.07.29-.09-.16-.09.12-.05.12-.22.05,0,.08.01.11.03,0-.04,0-.08,0-.13h0s0,.01,0,.01h0s-.02.04-.02.02h0s-.04.04-.06.05c0-.07.03-.04.06-.05l.02-.02h0s-.21-.05-.21-.05c0,.05.04.08.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.6,24.26s.02-.03.03-.04c-.03.01-.04.02-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.64,24.12s.1-.06.11-.02c-.02.07-.07.07-.12.12.06-.02.17-.05.19-.17h-.03c0-.09.13-.34.16-.36-.12.15-.21.26-.31.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.65,23.53l-.18-.03-.08.18.08-.08c.03.09.11-.02.18-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "199.58 22.49 199.76 22.35 199.47 22.51 199.58 22.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "199.43 22.37 199.57 22.24 199.45 22.29 199.43 22.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.35,16.09h-.07s.05,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.54,16.34l.08-.06s-.08.05-.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.22,19c.09-.17.26-.42.1-.26l-.15.16c.06,0,.06.05.05.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.11,17.5l-.04.06c.07-.04.13-.07.18-.11-.05.02-.09.03-.15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.41,18.07l.05-.16s-.04.1-.05.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M189.05,14.95l-.2.1c.05.06.11-.04.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.03,21.02c.02-.1.02-.15,0-.19-.05.13-.15.3,0,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.17,14.68s-.09.03-.12.06c.05,0,.09-.02.12-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.92,20.72s-.01.04-.02.06c.05,0,.1.01.12.06.03-.1.04-.18-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.21,10.04s0-.02.01-.03c-.02.02-.02.02-.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.8,7.27s.04.03.06.05c0-.02-.01-.04-.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.97,21.76s.02-.01,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.48,22.49s-.05.03-.09.06c.04-.03.07-.05.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.66,21.36h0s-.02.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.94,21.87s.01-.06.01-.08c0,.02-.01.04-.01.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.01,21.79s0,.03,0,.04c.03-.02.04-.04,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.92,21.73s.03.04.03.06c0-.02.01-.03.02-.03-.01,0-.02-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M187.77,12.25s0-.01,0-.02c-.1.03-.07.03,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "193.84 19.75 193.85 19.74 193.86 19.73 193.84 19.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.63,19.75c.24-.14.24-.09.23-.01l.43-.46-.66.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M189.81,15.57l-.08.2c-.32.12-.3-.02-.44.23.52-.43.31.26.84-.18l-.06.14s-.04,0-.05-.01c-.16.31.43-.25.47-.06,0,.08-.05.17-.14.2h.21s-.08.1-.1.06l.17.12h-.02c.1-.04.27-.1.34-.12-.04.1-.07.03-.13.09l.2-.02c-.1.15-.29.19-.32.12-.44.52.19-.04.04.39l-.13-.02c-.25.3-.09.27-.19.52.08-.1.3-.58.5-.6-.02.06,0,.11.14.07-.18.16-.09.17-.03.22l-.24.21c.13,0,.24-.11.39-.17.04.09-.13.27-.27.43.06.15.23-.34.39-.25,0,.18.15.16.39.15-.02.14-.16.12-.2.2l.24-.11s-.05.07-.09.09c.12-.02.24-.21.38-.19.28-.21-.24.5.14.33-.05.08-.16.12-.24.21.31-.04.24-.01.6-.14l-.07.23c.12-.23.41-.33.65-.41.06-.1.12-.19.15-.24h.24c-.03.06-.12.12-.24.19l.08-.03c-.05.12-.21.22-.37.31.03-.06.07-.12.11-.18-.17.1-.36.21-.49.35.03-.02.07-.02.1-.02-.05.03-.09.05-.11.08-.02.03.04,0,.12-.04l-.24.27.11-.09-.02.31c.37-.13.85-.38,1.12-.3-.23.13-.33.28-.56.48.2-.27-.23-.05-.26-.18.02.07-.1.16-.15.18l.37-.03c-.19.17-.11.16-.15.28.34-.37.36-.1.54-.14-.12.12-.26.22-.31.11-.2.34.54-.28.39.03-.02-.02-.01-.05-.08,0,.15-.05.17.14.04.21l-.02-.02c.08.17.37.41.7.14-.04.04-.4.33-.47.38l1.27-.73c-.29.23-.86.89-1.11.92,0,.07-.02.15.14.13.02-.06.34-.41.39-.4-.23.36-.11.2-.27.54.03-.09.48-.44.52-.37-.07.05-.41.39-.47.41l.53-.25c-.1.04-.36.32-.45.45.07-.09.09.12.17.11l.05-.14c.07.2.71-.39.82-.23-.1.06-.56.44-.55.56.24-.16,1.15-.79,1.43-.82l-.1.14.23-.03c-.37.24-1.2.69-1.54.83-.05.14-.13.15-.04.22-.09.13-.21.11-.24.1l.1.26c.24-.24.38-.09.58-.28l-.44.03c.24-.24.81-.53.89-.36-.07.12-.46.38-.54.46.1-.06.28-.03.23.04l-.18.07c-.02.16.44-.18.29.12.01.04-.23.39-.08.26.23-.31,1.09-1.13,1.33-1.29,0,.03-.12.41-.23.57-.17.26-.59.41-.74.63.07-.06.18-.11.21-.12-.03.09-.22.18-.12.22.26-.22.11.16.24-.16.13,0,.02.12.1.19.14-.18.61-.44.75-.44-.07.06-.13.15-.17.19.11.16.07.34.19.47-.05.07-.06.2-.19.27.06-.02.16-.09.21-.05-.14.28-.12-.06-.32.24.15-.13.3-.08.44-.11.21-.23-.08-.17-.22-.14.31-.29.72-.5.99-.5.18.03-.15.23-.09.21.14.25.7-.34.63.04-.13.25-.38.37-.51.52-.16-.02,0-.25-.07-.3l-.02.16c-.09.03-.2.02-.17-.06-.12.22.29.37.27.68.09-.04.2-.05.26-.15l-.07-.02c.11-.19.3-.12.32-.25.17-.04.42-.13.42.04l-.21.23c.06-.06.07-.19-.02-.15.13-.06-.16.43.17.19l.09-.21c.17-.04.49-.19.49-.04.18-.25-.04,0,.16-.3-.27.36-.19-.22-.44.18.24-.34.03-.22.21-.54-.07.07-.11.16-.14.06-.03.02-.06.04-.08.05h0s0,0,0,0c-.01,0-.02,0,0,0-.02.05-.04.1-.08.14-.2.13-.3.01-.42.06,0-.07.1-.06.16-.16l-.18.07c.16-.16.17-.37.35-.36l-.07-.09c.04-.14.01-.24-.1-.22,0-.07-.28.07-.12-.02l-.23-.04.04-.04c-.11-.15-.53-.02-.38-.45-.08,0-.18,0-.2-.12l.13-.15c-.1-.01-.02-.31-.19-.19.32-.42-.18-.36-.21-.52l-.19.17c-.06-.08-.17-.1-.33-.12l-.16.16c-.2.05-.06-.3-.19-.4.07-.05.08,0,.06.05.24-.49-.55-.05-.4-.43-.09.02-.09-.02-.07-.08,0,0,0,0,.02,0,0,0,0-.01-.01-.02.02-.04.03-.09.05-.13-.03.05-.05.09-.05.12-.03-.02-.08-.04-.16-.04l.16-.18s0,0-.01,0c.03-.1-.11.05-.23.19-.05,0-.1.02-.15.05.26-.29-.19,0,.08-.33-.17.11-.28-.08-.62.18.04-.04.05-.07.07-.05,0-.07,0-.15-.13-.1l.21-.22-.39.19c.09-.18.15-.28.37-.38-.39.11-.2-.02-.57.11l.15-.13s-.3.08-.2-.06c.2-.34-.37-.48-.32-.95-.39.44.1-.28-.25.01.09-.11.12-.19.24-.23-.21-.03,0-.32-.35-.15.09-.11.17-.11.22-.18-.03.01-.12.04-.07-.02.05-.07.1-.06.16-.08-.13-.11-.45.17-.76.42.09-.19.04-.2-.2-.07.08-.11.15-.23.25-.19-.02-.06-.09-.39-.33-.18.05-.07-.04-.07-.07-.06-.07-.11-.06-.14-.16-.21l-.02.06c-.32.22-.13-.02-.23-.07l.03-.02c.06-.36-.17.01-.08-.37l-.17.17c-.4.33.09-.35-.14-.32l-.07.13c-.18.06.39-.62.39-.71.02-.04.07-.03.11-.03.1-.34-.25.19-.4.13.11-.13.35-.26.31-.35.07-.13-.6.16-.44-.16-.08.11-.16.21-.28.23-.1-.05.19-.53-.18-.33.02-.03.04-.06.07-.08-.13.01-.3-.07-.5.04.58-.6-.62-.1-.04-.6l-.19-.15.06-.05c-.06-.15-.23-.07-.41,0,.02-.06.09-.09.12-.11-.03-.27-.07-.26-.48-.16l.18-.18c-.14.06.09-.5-.27-.47.02-.02.06-.04.1-.05-.38,0,.15-.89-.6-.38l-.27.02c.08.21-.32.23-.38.39-.09-.03.07-.34.17-.29l-.02.04c.38-.28-.04-.31.21-.51-.28-.3-.34-.77-.57-1.08l-.25.27-.07-.12c.04-.08.19-.22.24-.14.13-.17-.24-.01-.3.04,0-.24.37-.22.34-.27l-.07-.04-.02.04c-.16.05-.28.14-.34.04.01-.1.15-.17.14-.2.02-.02.02-.03-.02-.04l-.08-.15-.18.24c-.16.03-.09-.13-.29.14.31-.41-.26-.6-.19-.76-.23.05-.29-.03-.35-.15-.03.06-.27.28-.31.17.54-.39.1-.34.41-.72-.2.26-.26-.19-.53.19-.02-.11.19-.16.27-.32-.34,0-.17-.48-.41-.64-.07.05-.15.17-.29.21l.25-.39c-.07-.01-.43.28-.25.01-.05.06-.12.14-.17.13,0-.68-.96-.63-.66-1.56-.09.16-.13.14-.17.1,0,.05-.17.13-.26.21l.12-.38c-.29.17-.17-.18-.43,0l.09.02c-.35.16-.57.62-.95.91.4-.18-.32.61.27.37-.05.09-.14.07-.22.16.19-.09.26-.08.25.06l-.05.02c.21.19.13.41.22.74l.17-.17c.02.07-.03.13-.06.19.33-.16-.1-.16.25-.35-.32.37.29.38-.09.77.06.08.19-.2.26-.11l-.1.11.17-.1c.02.07-.1.22-.2.3,0-.02-.06-.01-.08-.02-.08.18.2.16.18.22v-.14c.29.14.36.53.77.55l.07-.09c.29.03.01.21.23.33h-.03c.12-.02.2-.01.23.04-.14.04-.13.25-.29.28.32.04.21-.02.62-.17l-.12.14c.16-.07.23-.12.34-.06-.18.03-.17.24-.4.29-.16.45.54.02.16.48.47-.24.09-.34.21-.36.1-.15.35-.17.36-.08.04.07-.42.52-.29.66-.01-.02-.04,0-.05,0-.05.14.23,0,.12.2.27-.16.06.1.37-.14l-.18-.08c.14.01.56-.21.49.06-.07.04-.18.07-.25.08-.06.11.12.02.06.14-.31.24-.2-.11-.51,0-.1.15.35-.03-.01.21.47-.29.07.19.47.03l-.19.15s.16-.05.18-.01l-.28.14c.27-.09-.04.31.13.29-.14-.16.19-.22.26-.4.41,0-.38.51-.1.67-.05,0,.01-.21.14-.23,0,.07-.02.19-.1.3.16.12.17-.18.33-.21-.18.24.15,0,.28,0l-.18.16c.03.27.42-.28.41,0l-.31.15.13.02-.22.16c.23-.04.21.02.23.15.11-.13.34-.27.41-.2-.07.14-.2.12-.08.2-.14.07-.3.17-.17-.02-.07.04-.13.08-.2.12-.08.16.09.16.12.2,0-.02-.01-.05,0-.08l.39-.06c-.05.08-.12.11-.19.14.05.01.15-.04.21,0-.16.11-.31.25-.44.24h.29c-.06.07-.11.23-.18.26-.02.16.46-.05.44.16.03-.02.07-.03.11-.03.05.13-.05.38.26.32l-.21.3c.14.04.26-.38.49-.31.18.04-.19.24-.23.34.18-.06.54-.2.41.09-.08,0-.06-.05-.11-.07ZM190.93,16.62c-.06.01-.21.07-.12-.04.23-.16.15-.05.12.04ZM192.91,17.98c-.07.04-.07-.01-.03-.1.03,0,.05.04.03.1ZM198.52,21.58s0,0-.01,0c.02-.11.01-.07.01,0ZM198.54,21.75s.06-.04.08-.06c-.05.04-.08.02-.09-.02-.04.05-.06.09,0,.09ZM188.75,10.88l-.03.06c-.09,0-.03-.03.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.49,18s.06-.07.09-.1c-.04.02-.07.05-.09.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "189.09 14.93 189.09 14.92 189.05 14.95 189.09 14.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.6,21.61s.03-.09.05-.12c-.04.04-.07.08-.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.33,21.98l-.11-.02s.01.07,0,.11c.04-.04.09-.11.11-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.79,23.57s.02.02.05,0l.08-.08s-.13,0-.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.81,22.6c-.14.15-.05.14.02.16h0c.22-.19.1-.17,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.84,22.76s.04.02.04.04c.09-.07,0-.03-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.75,21.78c-.02.06.2-.17.15-.1.21-.16-.36.08-.15.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "198.36 23.1 198.53 22.91 198.36 23.02 198.36 23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.16,22.62l.02.12s.06-.04.08-.04c-.04-.05-.05-.13-.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.26,22.7s.04.04.08.03c-.01-.01-.05-.03-.08-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "198.22 23.05 198.23 22.99 198.2 22.93 198.22 23.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.47,21.82l-.13-.03c-.07.05-.09.11-.04.11.06-.02.11-.02.16-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.19,22.53c.02-.06.06-.1.11-.17l-.23.21.12-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.93,22.35c-.07.05-.29.06-.18.14.07-.05.2-.02.18-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "196.11 20.91 196.13 20.92 196.5 20.57 196.11 20.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.24,20.69c0,.18.25-.19.22,0,.11-.06.03-.15.12-.2-.15.03-.12-.05-.34.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.58,20.48s.05-.01.08-.02c-.04,0-.06.01-.08.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "185.83 6.86 185.86 6.74 185.76 6.88 185.83 6.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.43,6.98l.24-.22-.26.14s.07.02.02.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.59,17.22l.06-.05c.05-.07.05-.08.03-.12l-.09.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "190.04 16.22 190.05 16.24 190.25 16.02 190.04 16.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M189.14,15.76s.09.03.11.07c-.09-.03.16-.31-.11-.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.01,8.09s-.18.07-.21.08c.06.01.26-.11.21-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "197.6 8.23 197.52 8.26 197.74 8.22 197.6 8.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.75,8.55c.31-.18-.11-.09-.02-.2l.07-.04-.27.1c.07.05.29.06.22.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.14,9.05c.12-.07.13-.01.02-.06-.01.01-.02.02-.03.02,0,0,0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.13,9.02s-.09.07,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.28,9.14h-.13c-.07.05-.07.1-.13.11.08.02.15-.03.26-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.53,9.07h-.06s-.04.03.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.35,9.07h.12s.15-.08-.05,0c.1-.04,0,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.39,9.02c.06-.06.09-.11.22-.12-.08-.06-.31.06-.22.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.1,8.41l.08-.08-.12.02c.06-.01-.06.11.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.24,9.5c.07-.03.18-.1.26-.15h-.09s-.07.1-.17.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.5,9.35h.14c0-.06-.07-.04-.14,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "197.89 8.91 197.61 8.95 197.9 8.92 197.89 8.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "197.32 9.69 197.15 9.74 197.41 9.67 197.32 9.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.41,9.8c-.14.04-.21.13-.3.15.04.02.17,0,.28-.02-.07,0-.07-.04.02-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.56,9.9s-.1.01-.17.03c.04,0,.09,0,.17-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.65,9.44s-.15.08-.18.13l.18-.11s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.66,9.46h0s0,.04,0,.05c0,0,0-.02,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.65,9.44s0,0,0,0c.02-.01.02-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.78,9.12c.12-.02.27-.02.4-.15-.14.04-.22.12-.4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.88,9.3l.02-.07c-.05.03-.12.07-.18.08h.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "197.95 9.3 197.88 9.3 197.87 9.33 197.95 9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.69,9.72c.09-.02.11,0,.14.03.02-.05.03-.09.02-.12-.06.02-.18.06-.16.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.7,9.59s0,0,.01,0c.01-.01.02-.02-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.96,10.03s.02-.01.03-.02c-.01,0-.02.01-.03.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.88,9.61s-.03-.03-.09-.02c.03,0,.05.02.06.04.03-.01.05-.02.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.68,9.93s.06-.06.09-.09c-.06.04-.14.11-.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.66,9.62s0,0-.01,0c-.04.03-.02.02.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.66,9.62s.08-.02.13-.03c-.02,0-.05,0-.08,0-.01,0-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.24,9.52c-.18.08-.37.1-.21-.04-.16.01-.73.33-1.04.53.08-.04.15-.07.28-.07.09-.06.17-.22.36-.26.12.02-.04.09-.12.16.21-.13.37-.07.69-.24h-.14c.05-.03.14-.05.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.97,9.9h-.03s-.08.08-.21.18c.1,0,.17-.03.23-.06l-.02-.12h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.89,9.79c.2-.08.31-.06.51-.2-.04-.06-.18.03-.29.04.1.08-.12.02-.2.15-.04,0-.06-.02-.08-.03-.02.03-.04.06-.06.09,0,0,0,0,.01,0h0s0,0,0,0c.02-.02.04-.02.02-.01,0,0,0,0,0,0,.03-.01.05-.02.08-.03-.03.05-.05.03-.08.03,0,0-.02,0-.03.01,0,0,0,0,0,0l.15.05s0-.06-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.63,8.82s-.03.02-.04.02c.03,0,.04-.01.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.53,8.92s-.11.04-.1,0c.05-.05.09-.04.16-.08-.06.01-.16.02-.24.11h.03c-.05.07-.27.23-.3.24.17-.09.29-.16.45-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.26,9.33l.14.04.15-.12-.1.05c.02-.07-.1,0-.18.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "197.87 10.08 197.66 10.17 197.97 10.08 197.87 10.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "197.95 10.18 197.77 10.26 197.89 10.24 197.95 10.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.09,15.28h.06s-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.02,15.1l-.09.04c.05-.01.09-.03.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.24,12.85c-.15.12-.39.28-.19.18l.19-.1s-.03-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M201.28,14.13s.04-.03.05-.04c-.07.02-.14.04-.2.06.04,0,.09-.02.14-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M202.1,13.77l-.1.11s.07-.07.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.76,16.16l.21-.07s-.11.02-.21.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.55,11.26c-.06.07-.08.11-.08.13.09-.09.25-.2.08-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.98,16.2s.09-.01.13-.04c-.04,0-.08,0-.13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.51,11.48s.02-.02.04-.04c-.04,0-.08-.02-.08-.05-.07.07-.11.12.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M205.28,19.77s-.01.01-.02.02c.03-.01.03-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.79,21.74s-.02-.02-.03-.04c-.01.01,0,.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.07,10.66s-.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.79,10.18s.05-.02.1-.04c-.05.02-.08.03-.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.84,11.14s0,0,0,0c.04-.03.03-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.14,10.58s-.04.04-.04.06c.01-.01.03-.03.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.05,10.63s0-.02,0-.03c-.03.01-.05.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.1,10.69s0-.03,0-.05c-.01.01-.02.02-.03.02,0,0,.01.01.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.85,18.13s0,0-.02.01c.09-.02.07-.02.02-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "201.56 12.48 201.55 12.49 201.55 12.49 201.56 12.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M201.75,12.5c-.26.08-.24.05-.2,0l-.55.3.75-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.35,15.68l.15-.14c.32-.07.25.03.47-.14-.62.28-.17-.2-.79.09l.11-.1s.04,0,.04.01c.26-.21-.47.16-.43.02.03-.06.11-.12.19-.13h-.19s.11-.08.11-.05l-.1-.09h.02c-.1.02-.27.06-.34.07.07-.07.07-.02.15-.06h-.18c.15-.09.33-.11.32-.06.58-.35-.18.02.12-.28l.11.02c.33-.2.18-.19.37-.36-.11.07-.48.39-.67.4.04-.04.05-.08-.09-.06.22-.1.15-.11.11-.15l.29-.13c-.11,0-.25.06-.4.1,0-.07.22-.19.4-.29,0-.11-.33.23-.43.15.08-.12-.07-.12-.28-.12.08-.1.18-.08.25-.13l-.25.06s.07-.04.11-.06c-.11,0-.29.13-.4.11-.33.14.41-.34.01-.25.07-.06.18-.08.29-.13-.29.01-.21,0-.57.06l.16-.16c-.19.16-.48.21-.72.25-.1.07-.18.13-.22.16l-.2-.02s.15-.07.27-.11c-.03,0-.05.01-.08.02.09-.08.27-.15.44-.2-.05.04-.11.08-.16.12.19-.06.39-.13.56-.22-.04,0-.07.01-.09,0,.05-.02.09-.03.12-.05.03-.02-.04,0-.12.02l.31-.17-.13.06.14-.22c-.37.07-.88.22-1.08.14.25-.08.39-.18.67-.31-.28.18.18.05.15.15.01-.05.15-.11.2-.12h-.33c.23-.11.16-.11.24-.19-.44.24-.35.05-.51.06.15-.08.31-.14.3-.06.31-.23-.57.16-.32-.04.01.01,0,.03.07,0-.15.03-.09-.11.06-.15h.01c0-.11-.15-.3-.54-.13.05-.02.47-.21.55-.24l-1.38.43c.34-.14,1.09-.58,1.32-.58.04-.05.08-.1-.06-.1-.04.04-.46.27-.5.26.34-.24.18-.14.45-.36-.06.06-.59.28-.59.23.08-.03.51-.25.57-.26l-.55.14c.1-.02.43-.2.57-.29-.09.06-.03-.09-.09-.09l-.1.1c.02-.15-.77.23-.79.11.11-.04.66-.27.7-.36-.27.1-1.31.48-1.55.48l.14-.09h-.2c.41-.13,1.3-.39,1.65-.47.1-.1.17-.09.13-.15.13-.09.23-.07.24-.05l.02-.19c-.3.15-.36.03-.61.16h.39c-.3.16-.9.33-.9.2.11-.08.55-.24.65-.29-.11.04-.25,0-.18-.05l.18-.03c.09-.11-.45.1-.19-.11,0-.03.36-.26.18-.18-.33.2-1.4.72-1.67.82.02-.02.27-.28.43-.39.25-.17.68-.25.89-.39-.08.04-.2.06-.23.07.06-.06.26-.11.2-.15-.31.14-.03-.12-.27.1-.11-.01.04-.09,0-.14-.19.11-.7.27-.82.25.08-.03.18-.09.22-.12-.02-.12.09-.25.04-.35.07-.04.14-.14.28-.18-.06.01-.17.05-.19.02.24-.19.07.05.37-.15-.18.08-.29.04-.42.04-.27.15,0,.13.13.12-.38.18-.82.29-1.04.27-.13-.04.23-.15.17-.14,0-.19-.73.18-.52-.08.22-.17.48-.23.65-.33.12.02-.1.18-.07.22l.09-.11c.09-.02.17,0,.12.06.2-.15-.08-.29.06-.5-.09.02-.19.02-.28.08l.05.02c-.18.13-.31.06-.37.15-.16.01-.41.06-.33-.07l.27-.15c-.08.04-.14.13-.05.11-.14.03.32-.29-.06-.15l-.17.14c-.16.01-.49.09-.43-.02-.26.16.04,0-.26.2.38-.23.06.17.45-.09-.35.22-.12.16-.41.37.09-.05.16-.1.15-.03.03-.01.06-.02.09-.03,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,.02,0,0,0,.03-.03.08-.07.13-.09.22-.07.26.02.38,0-.03.05-.11.04-.2.1l.18-.03c-.2.1-.3.25-.45.23l.02.07c-.09.09-.11.17-.01.16-.03.05.26-.03.09.02l.18.05-.05.03c.02.12.44.06.13.35.07.01.15.02.12.1l-.17.09c.08.02-.11.22.08.15-.45.27,0,.27-.04.39l.23-.11c.01.06.1.08.23.11l.2-.1c.19-.02-.07.22,0,.3-.08.03-.07,0-.03-.04-.4.33.44.08.16.34.09,0,.07.02.03.06,0,0,0,0-.01,0,0,0,0,0,0,.01-.03.03-.06.06-.09.09.04-.03.08-.06.09-.08.01.02.05.04.12.04l-.21.12s0,0,0,0c-.07.07.11-.03.27-.12.04,0,.09,0,.15-.02-.34.19.15.02-.21.23.19-.07.21.08.6-.09-.05.02-.07.04-.08.03-.03.05-.06.11.06.08l-.27.15.41-.11c-.15.12-.24.19-.47.25.38-.05.16.02.53-.04l-.18.08s.28-.04.15.05c-.31.23.12.37-.11.7.51-.28-.2.2.21,0-.12.07-.18.13-.3.15.17.03-.13.23.24.13-.12.07-.19.07-.26.11.03,0,.12-.02.05.02-.07.04-.11.04-.17.05.06.08.45-.09.82-.25-.15.13-.11.14.14.06-.11.07-.22.16-.29.12,0,.04-.08.28.21.15-.07.05,0,.06.04.05.02.08,0,.1.06.16l.04-.04c.36-.14.11.02.18.06l-.04.02c-.19.25.15,0-.08.27l.21-.11c.47-.21-.22.25,0,.24l.11-.09c.18-.03-.58.42-.62.49-.04.03-.07.02-.11.02-.22.24.29-.12.4-.07-.15.09-.4.17-.4.23-.11.09.57-.08.31.14.11-.07.22-.14.33-.15.07.04-.37.37.02.24-.03.02-.06.04-.09.05.12,0,.23.07.44,0-.73.4.49.1-.2.43l.1.12-.07.03c0,.11.18.06.36.01-.04.04-.11.06-.15.07-.08.19-.04.19.35.14l-.22.12c.14-.03-.26.35.06.35-.03.01-.07.03-.11.03.33.02-.46.63.38.3h.25c0-.15.36-.15.47-.27.07.02-.19.24-.26.2l.04-.03c-.44.18-.08.22-.37.35.13.23,0,.57.09.8l.32-.18.02.09c-.07.06-.25.15-.26.09-.17.12.2.02.27-.01-.08.17-.41.14-.4.18l.05.03.03-.03c.15-.03.3-.09.31-.02-.05.07-.19.12-.2.14-.02.01-.03.02,0,.03l.02.11.24-.16c.15-.02.03.1.3-.09-.42.28,0,.44-.11.55.22-.03.24.03.26.12.05-.04.33-.19.33-.11-.62.26-.21.24-.62.5.27-.18.16.15.53-.12-.02.08-.23.11-.35.22.29.01-.02.35.13.47.08-.04.19-.12.32-.14l-.36.27c.05.01.47-.19.22,0,.06-.04.16-.1.19-.09-.24.49.61.47.03,1.13.13-.12.16-.09.18-.06.03-.04.2-.09.3-.15l-.24.27c.31-.12.09.13.38,0l-.07-.02c.36-.11.71-.43,1.15-.63-.41.12.49-.43-.11-.27.08-.06.15-.05.24-.11-.2.06-.25.05-.19-.05l.05-.02c-.12-.14.03-.29.07-.53l-.21.11c.01-.05.07-.09.12-.14-.35.11.03.12-.34.25.41-.26-.12-.28.35-.55-.03-.06-.24.14-.26.07l.13-.08-.18.07c0-.05.17-.15.28-.21,0,.02.04.01.06.02.13-.13-.12-.12-.08-.16l-.06.1c-.2-.1-.12-.38-.47-.41l-.1.06c-.24-.03.07-.15-.08-.24h.03c-.11.01-.18,0-.19-.04.13-.02.2-.17.35-.19-.26-.03-.19.01-.6.1l.16-.1c-.17.04-.25.08-.32.03.17-.01.24-.16.45-.19.3-.31-.47-.03.04-.35-.49.16-.2.24-.32.25-.14.1-.37.11-.35.05-.01-.05.56-.36.5-.46,0,.01.04,0,.04,0,.1-.1-.2,0-.03-.15-.29.1-.02-.07-.38.09l.13.06c-.12-.01-.56.13-.41-.06.08-.03.18-.04.25-.05.09-.08-.1-.02,0-.1.36-.16.14.09.44.02.14-.1-.31,0,.09-.15-.51.19.01-.14-.4-.04l.22-.1s-.15.03-.16,0l.3-.09c-.27.05.15-.22,0-.21.06.12-.25.15-.38.28-.36-.01.52-.35.34-.47.04,0-.09.15-.2.16.03-.05.09-.13.19-.21-.1-.09-.21.12-.37.14.24-.16-.13,0-.24-.01l.22-.1c.08-.19-.47.18-.36-.01l.33-.1-.11-.02.25-.11c-.21.02-.18-.02-.14-.12-.15.09-.4.18-.43.13.11-.1.22-.08.15-.14.15-.05.33-.11.14.02.07-.03.15-.05.22-.08.13-.11-.02-.12-.03-.15,0,.02,0,.03-.04.06l-.36.03c.07-.06.15-.07.22-.09-.03-.01-.14.02-.18,0,.18-.08.36-.16.47-.16l-.25-.02c.07-.04.18-.16.26-.17.08-.11-.42.01-.32-.13-.04.01-.07.02-.11.01,0-.1.19-.27-.1-.24l.29-.2c-.11-.04-.37.26-.54.2-.14-.04.26-.16.33-.23-.18.03-.54.12-.32-.08.07,0,.03.04.07.05ZM202.79,14.88c.05,0,.21-.04.09.04-.26.1-.15.03-.09-.04ZM201.64,13.8c.08-.02.05.01-.02.08-.03,0-.03-.03.02-.08ZM198.37,10.83s0,0,.01,0c-.07.08-.04.05-.01,0ZM198.43,10.7s-.06.02-.09.04c.06-.02.07,0,.06.02.05-.03.09-.06.03-.06ZM202.5,19.07l.05-.04c.08,0,.02.02-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M202.01,13.81s-.07.04-.12.06c.04-.01.08-.03.12-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.72,16.17s0,0,0,0c.01,0,.03-.01.04-.02h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.85,11.04s-.06.06-.1.08c.05-.02.1-.05.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.86,10.47l.08.02s.02-.05.05-.08c-.05.03-.12.07-.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199,9.39s-.01-.01-.04,0l-.1.05s.11.01.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.56,10.07c.18-.09.1-.09.05-.11,0,0,0,0,0,0-.26.11-.16.11-.06.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.6,9.96s-.02-.02-.02-.03c-.1.04-.02.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M198.26,10.66s-.24.1-.17.06c-.24.09.33-.02.17-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "199.15 9.76 198.93 9.88 199.12 9.81 199.15 9.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.12,10.12l.04-.09s-.06.02-.08.02c0,.04-.02.1.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.07,10.05s-.02-.03-.06-.03c0,0,.02.03.06.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "199.26 9.8 199.22 9.84 199.22 9.89 199.26 9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.36,10.74l.09.03c.08-.03.12-.07.08-.08-.06.01-.1,0-.17.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M199.89,10.26s-.09.06-.16.11l.28-.13-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M200.04,10.41c.08-.03.27-.02.21-.09-.08.03-.17,0-.21.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "200.12 11.5 200.11 11.49 199.66 11.71 200.12 11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M201.61,11.79c.08-.12-.29.12-.19-.01-.12.03-.09.11-.19.13.14-.01.08.04.37-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M201.24,11.91s-.05,0-.08.01c.03,0,.06,0,.08-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "203.62 22.03 203.55 22.12 203.69 22.02 203.62 22.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M204.01,21.96l-.29.15.28-.1s-.05-.01,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.32,14.47l-.07.03c-.07.04-.07.06-.07.08l.15-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "203.4 15.2 203.4 15.19 203.15 15.34 203.4 15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M203.99,15.57s-.07-.02-.07-.05c.07.02-.26.21.07.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.64,36.89s.09-.17.1-.2c-.07.02-.12.26-.1.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "193 37.15 193.04 37.08 192.89 37.25 193 37.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.55,36.98c-.08.35.18,0,.22.16l-.02.08.14-.26c-.11,0-.31.14-.34.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.58,36.17c-.03.14-.09.09.04.06,0-.02,0-.02,0-.04-.01,0-.02,0-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.62,36.19c.05,0,.01-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.38,36.19l.11-.09c.02-.08-.03-.12,0-.17-.09.04-.1.12-.11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.23,36.41l.05-.04s0-.05-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.39,36.29l-.11.08c-.01.06-.05.17.05-.03-.04.1,0,0,.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.41,36.36c0,.09.04.15-.07.24.14,0,.21-.24.07-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.4,37.32v.12s.09-.1.09-.1c-.04.05-.06-.12-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M192.05,35.87c-.03.07-.05.2-.08.29l.08-.06c0-.06-.03-.12,0-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.98,36.16l-.11.1c.06.04.09-.02.11-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "192.08 36.78 192.29 36.56 192.06 36.77 192.08 36.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "191.79 35.76 191.89 35.61 191.73 35.84 191.79 35.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.61,35.73c.08-.13.04-.25.11-.32-.06,0-.14.11-.22.2.06-.04.1-.01.11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.38,35.74s.07-.08.12-.13c-.03.02-.07.06-.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.76,36.18s.04-.16.02-.22l-.05.21h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.73,36.17h0s-.05-.03-.05-.04c0,0,.02.02.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.76,36.18h0s0,.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.97,36.53c-.08.1-.21.19-.19.39.08-.13.07-.24.19-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.7,36.45l.06.07c.02-.05.03-.14.07-.18l-.13.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "191.65 36.5 191.7 36.45 191.68 36.42 191.65 36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.44,35.98c-.06.08-.1.07-.15.07.03.05.06.09.1.11.03-.06.09-.17.04-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.57,36.09h-.01s0,.03.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "190.91 35.91 190.9 35.94 190.91 35.91 190.91 35.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.39,36.19c.02.05.05,0,.09-.05-.03.01-.06.02-.09,0-.01.03-.02.05,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.24,35.8s0,.09.01.13c0-.07.01-.18-.01-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.57,36.04h0c0-.05,0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.57,36.04s-.06.07-.09.11c.02,0,.05-.02.08-.05,0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.33,37.15c.07-.18.22-.33.22-.1.12-.11.3-.74.36-1.11-.03.08-.06.16-.17.24-.01.11.07.3-.05.44-.13.06-.05-.09-.07-.21-.04.25-.24.29-.35.64l.13-.09c-.02.05-.08.13-.07.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.03,36.01h.04c-.02-.06-.02-.14-.01-.3-.08.07-.12.14-.14.2l.14.08-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.2,36.05c-.1.19-.2.25-.24.49.09.02.12-.15.21-.22-.16,0,.08-.1.02-.25.04-.02.07-.03.1-.03-.02-.03-.03-.07-.04-.12h0s0,.01,0,.01h0s0,.05,0,.03h0s-.02.05-.03.08c-.03-.06.01-.05.03-.07v-.03s.01,0,.01,0l-.18.06s.06.05.13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.54,37.32s0-.03.01-.05c-.02.02-.03.04-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.53,37.18s.06-.1.08-.07c0,.07-.04.1-.06.16.04-.05.12-.12.1-.24l-.02.02c-.03-.09-.01-.37,0-.39-.05.19-.08.32-.11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M191.34,36.66l-.15.06v.2s.03-.11.03-.11c.05.07.08-.07.12-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "190.93 35.8 191.02 35.59 190.85 35.87 190.93 35.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "190.77 35.77 190.84 35.59 190.76 35.68 190.77 35.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.33,35.28l-.05.04s.04-.03.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.58,35.37l.03-.09s-.04.08-.03.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.98,34.49c0-.19.04-.48-.02-.27l-.05.21s.07,0,.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.98,34.89v.07c.03-.07.06-.13.09-.19-.03.04-.06.08-.09.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.68,35.74l-.03-.15c0,.05,0,.1.03.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.89,35.11l-.1.2c.06.02.07-.1.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M189.17,35.29c-.02-.1-.04-.14-.07-.16.01.14,0,.33.07.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.08,33.1s-.05.07-.07.12c.03-.03.06-.07.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M188.97,35.09s0,.04,0,.06c.04-.02.09-.04.12-.01,0-.1-.03-.17-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M174.92,33.61s0-.02,0-.03c0,.03,0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M173.94,31.12s.04,0,.07,0c0-.02-.03-.02-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.18,35.46s.01-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.05,36.33s-.03.05-.05.09c.02-.05.04-.08.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M188.21,36.25h0s0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.2,35.57s-.01-.06-.02-.08c0,.02,0,.04.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.23,35.47s.02.02.02.03c.02-.03.02-.06-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.13,35.46s.03.02.05.04c0-.02,0-.03,0-.03-.01,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M177.76,33.74s0-.01,0-.02c-.06.08-.04.07,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "185.43 36.35 185.44 36.34 185.43 36.33 185.43 36.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.26,36.47c.13-.24.15-.2.17-.13l.15-.61-.32.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.71,35.16l.03.21c-.19.28-.23.15-.23.44.2-.65.34.03.54-.62v.15s-.01.03-.03.02c.01.34.22-.45.32-.32.03.06.04.17-.02.24l.15-.13s-.01.13-.04.11h.18s0,.01,0,.01c.05-.1.15-.24.2-.3.01.11-.04.06-.05.15l.14-.13c-.01.18-.14.32-.19.28-.11.67.12-.14.19.29l-.11.06c-.06.39.05.27.08.53.01-.13-.02-.64.13-.77.01.06.04.09.13-.02-.07.23,0,.19.07.2l-.1.3c.1-.07.14-.23.22-.35.07.05.01.3-.03.5.11.09.03-.41.19-.42.07.15.18.04.35-.1.04.13-.07.18-.07.28l.14-.23s-.01.08-.03.12c.08-.08.1-.3.21-.36.13-.33.02.54.24.19,0,.09-.07.18-.1.3.22-.21.18-.14.4-.45l.04.23c0-.25.18-.49.33-.69,0-.12.01-.22.02-.27l.18-.12c0,.06-.05.16-.11.28l.05-.07c.01.13-.07.3-.15.46,0-.06,0-.13.01-.2-.09.18-.18.37-.23.55.02-.03.05-.06.07-.07-.02.05-.04.09-.05.12,0,.03.03-.03.07-.1l-.08.35.05-.13.1.27c.23-.3.49-.78.73-.85-.13.23-.14.4-.23.7.05-.33-.19.09-.27,0,.04.05-.01.19-.04.23l.27-.23c-.08.24-.02.19,0,.31.11-.49.23-.28.35-.4-.05.16-.12.32-.19.25-.02.39.3-.52.3-.18-.02,0-.03-.03-.06.05.1-.13.18.03.11.16h-.02c.13.1.44.14.59-.26-.02.05-.18.48-.21.56l.7-1.28c-.14.34-.32,1.2-.5,1.35.02.06.04.13.15.03,0-.06.1-.52.15-.54-.04.42,0,.23,0,.59-.01-.09.21-.62.26-.58-.04.08-.17.54-.21.59l.31-.49c-.07.08-.15.45-.17.61.02-.11.12.05.17,0l-.02-.14c.13.13.4-.7.55-.62-.06.1-.27.66-.21.76.13-.26.6-1.26.8-1.43l-.03.16.17-.14c-.2.39-.68,1.19-.89,1.5.02.14-.04.19.05.2-.02.16-.12.21-.15.21l.17.16c.1-.32.26-.27.34-.54l-.33.26c.1-.32.43-.86.55-.76,0,.14-.22.56-.25.67.06-.1.21-.16.19-.08l-.12.15c.04.15.27-.38.27-.04.03.03-.04.44.03.26.07-.38.44-1.51.57-1.77,0,.03.06.41.03.6-.04.3-.31.65-.35.91.03-.09.1-.18.12-.21,0,.09-.11.26-.02.25.12-.32.14.08.13-.26.11-.07.06.09.15.11.04-.22.32-.68.43-.75-.03.08-.05.19-.06.24.14.08.17.26.31.31-.01.08.02.2-.06.33.04-.05.1-.15.14-.15-.01.31-.11,0-.16.37.07-.19.2-.22.3-.31.08-.3-.12-.11-.23-.01.14-.4.39-.78.6-.91.15-.06-.04.28,0,.23.2.15.43-.63.52-.28-.02.28-.17.51-.22.69-.13.06-.09-.21-.16-.22l.04.15c-.06.07-.15.12-.16.03-.02.25.36.17.45.44.06-.07.14-.14.16-.25l-.07.02c.02-.22.2-.25.17-.37.12-.12.28-.31.35-.16l-.08.3c.03-.09,0-.2-.06-.12.09-.11.02.45.2.09v-.23c.12-.12.32-.39.38-.27.06-.3-.03.03.02-.33-.09.44-.23-.1-.29.37.07-.41-.06-.21-.02-.57-.03.1-.03.19-.09.12-.02.03-.03.06-.05.08h0s0,0,0,0c0,.01,0,.02,0,0,0,.05,0,.1-.01.16-.12.21-.23.16-.31.25-.03-.06.06-.1.07-.21l-.12.15c.07-.21,0-.39.15-.48l-.09-.04c-.02-.14-.08-.21-.16-.14-.03-.06-.2.19-.1.04l-.2.08.02-.05c-.14-.08-.43.24-.46-.2-.07.04-.14.08-.21,0l.05-.19c-.09.04-.13-.25-.22-.07.1-.52-.28-.21-.36-.34l-.09.24c-.07-.04-.17,0-.3.07l-.07.21c-.14.15-.16-.22-.3-.25.04-.08.06-.05.07.01,0-.53-.45.24-.48-.16-.06.07-.08.03-.09-.03,0,0,0,0,.01,0,0,0,0,0-.01,0,0-.04,0-.09-.01-.13,0,.06,0,.1,0,.13-.03,0-.08,0-.14.05l.06-.23s0,0-.01,0c-.01-.1-.07.1-.1.28-.03.03-.07.07-.1.12.09-.38-.15.09-.06-.32-.09.18-.25.08-.41.47.02-.05.01-.08.04-.08-.03-.06-.06-.12-.14-.02l.08-.3-.23.36c0-.2,0-.31.14-.51-.26.3-.16.09-.39.39l.07-.19s-.2.22-.17.06c.02-.39-.47-.21-.62-.62-.13.57-.04-.29-.19.14.03-.14.01-.22.09-.32-.17.09-.13-.27-.33.07.03-.14.09-.18.1-.27-.02.03-.08.1-.07.02.01-.08.05-.1.09-.16-.14-.02-.28.38-.41.76-.01-.2-.05-.19-.18.05.02-.13.02-.27.11-.29-.04-.03-.23-.27-.33.03,0-.08-.06-.04-.08-.01-.1-.05-.1-.08-.21-.08v.06c-.14.36-.1.06-.19.08v-.04c-.09-.32-.11.1-.2-.26l-.06.23c-.17.49-.08-.34-.24-.18v.14c-.11.15.04-.72,0-.8,0-.05.04-.06.07-.09-.07-.34-.11.29-.25.33.03-.17.15-.4.08-.46,0-.14-.38.46-.4.12-.01.13-.03.26-.11.34-.1.02-.08-.54-.28-.17,0-.04,0-.07.01-.1-.09.08-.26.11-.36.31.17-.81-.51.27-.29-.46l-.21-.02.03-.07c-.11-.08-.21.08-.3.24-.01-.06.03-.12.04-.16-.14-.2-.17-.17-.42.15l.05-.24c-.08.13-.16-.45-.42-.22,0-.03.03-.07.05-.1-.28.22-.3-.8-.61.05l-.19.18c.15.11-.13.37-.1.53-.08.03-.1-.31,0-.33v.05c.16-.45-.17-.22-.08-.53-.34-.07-.61-.41-.92-.51l-.06.36-.11-.05c0-.09.03-.29.11-.25.01-.21-.18.13-.2.21-.12-.18.17-.4.12-.42h-.07s0,.05,0,.05c-.09.13-.14.28-.23.24-.04-.09.03-.23,0-.25,0-.02,0-.04-.03-.02l-.13-.07-.02.29c-.1.12-.13-.05-.15.28.03-.51-.48-.31-.5-.48-.14.18-.22.16-.32.1.01.06-.05.38-.13.32.2-.64-.1-.32-.05-.81-.01.33-.28.01-.29.48-.06-.07.06-.24.04-.41-.25.2-.36-.26-.61-.23-.02.08-.02.22-.1.34v-.46c-.07.03-.18.48-.19.17,0,.07-.02.19-.05.21-.34-.53-.98.12-1.25-.77.02.18-.02.19-.07.18.02.05-.05.21-.07.33l-.11-.37c-.11.31-.21-.03-.3.28l.07-.04c-.16.34-.08.83-.2,1.3.18-.39.09.67.37.11,0,.1-.06.14-.07.26.08-.19.14-.22.2-.11l-.02.05c.24,0,.29.22.52.42l.04-.23s.04.12.05.18c.15-.33-.15-.06,0-.43-.04.49.39.1.31.65.08.02.04-.27.12-.25v.15s.05-.18.05-.18c.05.04.03.23,0,.35,0-.02-.05.02-.06.03.03.19.22,0,.23.05l-.06-.11c.27-.08.5.18.8-.05v-.11c.23-.16.12.15.33.11v.02c.05-.1.12-.14.16-.11-.08.11.03.27-.07.39.24-.17.13-.15.36-.52l-.02.19c.08-.15.11-.24.22-.26-.12.13-.01.29-.15.47.1.44.39-.32.34.28.22-.47-.1-.32-.02-.41,0-.17.17-.35.22-.29.06.03-.06.66.1.7-.02,0-.03.03-.04.02.03.14.16-.14.18.08.12-.29.09.04.2-.34l-.17.05c.11-.08.3-.51.38-.25-.03.07-.1.17-.14.21,0,.12.1-.05.11.07-.11.38-.2.04-.36.31,0,.17.24-.23.09.17.2-.51.14.11.35-.27l-.07.23s.09-.13.12-.12l-.14.28c.15-.23.11.27.23.15-.17-.04.04-.29,0-.47.3-.25-.04.63.23.59-.04.02-.08-.17,0-.26.03.06.07.16.06.29.17,0,.04-.24.15-.36-.02.29.11-.09.2-.16l-.06.23c.14.2.18-.47.29-.25l-.16.3.11-.06-.09.26c.15-.17.16-.11.23-.01.02-.17.13-.42.21-.4.02.15-.09.21.03.21-.07.14-.14.31-.13.09-.03.07-.06.14-.09.21.02.17.14.08.18.09-.01-.01-.03-.03-.03-.07l.25-.28c0,.09-.04.16-.08.22.04-.02.09-.12.15-.12-.07.19-.12.38-.21.45l.21-.17c-.01.08.02.25-.02.31.06.14.31-.31.39-.13.02-.03.04-.07.07-.09.1.07.13.33.33.11l-.02.36c.12-.05.02-.45.23-.53.15-.07-.04.3-.02.41.11-.15.31-.47.34-.16-.05.05-.07,0-.11.01ZM181.99,35.37s-.13.18-.11.04c.11-.26.09-.12.11-.04ZM184.03,35.39c-.04.07-.06.02-.06-.07.03-.01.05,0,.06.07ZM189.76,35.52s0,0,0,.01c-.02-.11-.02-.07,0-.01ZM189.83,35.66s.03-.06.04-.09c-.03.05-.05.05-.08.02-.01.06-.01.11.04.07ZM177.82,32.07v.07c-.06.05-.03,0,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.72,35.64s.02-.08.03-.13c-.02.04-.04.08-.03.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "179.91 35.07 179.91 35.06 179.89 35.11 179.91 35.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M187.47,37s0-.09,0-.13c-.02.06-.03.11,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.56,35.48l-.09.03s.03.06.04.1c.02-.05.03-.14.05-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.66,37.1s.02,0,.04-.02l.04-.11s-.11.07-.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.35,36.26c-.06.19,0,.14.07.13h0c.11-.27.03-.2-.06-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.43,36.38s.04,0,.05.01c.04-.1-.01-.03-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M190.02,35.58c0,.06.1-.24.09-.16.11-.23-.26.24-.09.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "190.17 36.9 190.23 36.66 190.14 36.84 190.17 36.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M189.84,36.59l.06.09s.03-.06.05-.07c-.05-.03-.08-.09-.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M189.94,36.61s.05.02.08-.02c-.01,0-.05,0-.08.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "190.03 36.93 190.03 36.88 189.98 36.84 190.03 36.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M189.01,36.25l-.11.04c-.04.08-.03.14.01.11.04-.05.08-.07.1-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M189.04,36.98c0-.06.01-.11.03-.19l-.1.29.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M188.77,36.97c-.04.08-.21.19-.09.21.04-.08.15-.12.09-.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "187.61 36.15 187.63 36.16 187.79 35.67 187.61 36.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.08,36.93c.06.15.12-.29.17-.12.06-.11-.04-.14.02-.23-.1.1-.11.02-.19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.27,36.58s.03-.04.06-.06c-.03.02-.04.04-.06.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "173.76 30.8 173.71 30.68 173.72 30.86 173.76 30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M173.54,31.14l.06-.32-.11.28s.05-.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.98,36.06l.03-.07c.01-.08,0-.09-.03-.12v.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.16 35.56 181.18 35.57 181.23 35.28 181.16 35.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.31,35.7s.08-.03.11-.01c-.08.03-.02-.34-.11.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M188.02,44.78s.03-.19.04-.23c-.05.04-.04.28-.04.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "187.5 45.23 187.51 45.14 187.43 45.35 187.5 45.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M187.03,45.2c.02.36.17-.05.25.08v.08s.06-.28.06-.28c-.1.04-.25.22-.31.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.82,44.41c0,.14-.06.12.06.05,0-.02,0-.02,0-.04-.01,0-.02,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.87,44.42s-.03-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.64,44.49l.07-.12c0-.08-.07-.1-.04-.16-.07.06-.06.15-.03.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.56,44.75l.04-.05s-.01-.05-.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.68,44.59l-.08.11c0,.06,0,.17.04-.04-.01.11,0,0,.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.71,44.65c.03.08.08.13,0,.25.13-.04.12-.29,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.99,45.56l.04.11.05-.12c-.02.06-.09-.1-.09.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.24,44.28c0,.08.01.2.01.3l.05-.08c-.02-.05-.07-.1-.06-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.25,44.58l-.08.13c.06.02.08-.04.08-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "186.53 45.14 186.66 44.87 186.51 45.14 186.53 45.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "185.97 44.26 186.02 44.08 185.93 44.35 185.97 44.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.79,44.28c.04-.14-.03-.25,0-.34-.05.02-.1.15-.14.26.04-.06.09-.04.14.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.58,44.36s.05-.1.07-.16c-.02.03-.05.08-.07.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.05,44.67s0-.17-.04-.22l.02.21s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.03,44.67h0s-.05-.02-.06-.02c0,0,.03,0,.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.06,44.67s0,0,0,0c0,.02,0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.35,44.94c-.05.12-.14.24-.07.43.04-.14,0-.25.07-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.08,44.94l.07.05c0-.06,0-.14.02-.2l-.09.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "186.04 45 186.08 44.94 186.05 44.92 186.04 45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.7,44.57c-.04.09-.07.1-.12.11.04.04.09.07.13.07,0-.07.03-.19-.01-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.86,44.63s0,0,0,.01c0,.02,0,.02,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.18,44.65s0,.03,0,.04c0-.01,0-.02,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.71,44.79s.05,0,.08-.07c-.03.02-.05.03-.08.03,0,.03,0,.05,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.46,44.45s.03.08.05.12c-.01-.07-.04-.18-.05-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.84,44.59s0,0,0,0c0-.05,0-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.84,44.59s-.03.08-.05.13c.02-.02.04-.04.06-.07,0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.99,46.02c.02-.2.11-.38.18-.16.08-.14.07-.8.02-1.16,0,.09-.01.17-.09.28.02.11.15.26.08.44-.11.1-.08-.07-.12-.18.03.25-.15.35-.14.72l.09-.12c0,.06-.04.14-.02.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.33,44.72l.03-.02s-.05-.12-.09-.27c-.06.09-.07.17-.08.23l.15.04v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.5,44.7c-.04.21-.12.3-.08.54.09,0,.07-.18.13-.27-.15.05.05-.12-.05-.25.03-.03.06-.04.08-.05-.02-.03-.05-.06-.07-.1,0,0,0,0,0,.01h0s0,0,0,0c0,.03,0,.04,0,.03,0,0,0,0,0,0,0,.03,0,.06-.01.08-.04-.05,0-.06.01-.08,0-.01,0-.02,0-.03,0,0,0,0,0,0l-.15.11s.07.03.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.18,45.82s0-.03,0-.05c-.01.03-.02.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M186.12,45.69s.03-.11.06-.09c.03.07,0,.1,0,.17.02-.06.08-.15.02-.26v.03c-.07-.08-.13-.35-.12-.38,0,.19.01.33.04.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.81,45.25l-.13.1.05.19v-.11c.07.05.06-.09.08-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "185.17 44.54 185.2 44.32 185.11 44.64 185.17 44.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "185.01 44.56 185.03 44.37 184.98 44.48 185.01 44.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M175.9,46.53l-.04.05s.03-.03.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M176.16,46.55v-.1c0,.05-.01.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.1,44.37c-.04-.19-.09-.48-.09-.25v.22s.07-.01.09.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M178.36,45.52s0,.04.01.07c.02-.07.03-.14.05-.21-.02.04-.04.09-.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M178.27,46.41l-.06-.14s.03.1.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M174.46,46.68l-.05.22c.07,0,.04-.11.05-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.38,44.55c-.04-.09-.07-.12-.11-.14.05.13.08.32.11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M176.13,44.23s-.04.08-.04.13c.02-.04.04-.08.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.14,44.41s.01.03.02.05c.04-.03.07-.06.11-.05-.04-.09-.08-.15-.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.32,46.22s0-.01-.01-.03c0,.03,0,.03.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.93,43.95s.04-.01.06-.01c-.01-.02-.03-.02-.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.38,44.43s0-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.5,45.3s-.02.05-.02.1c0-.05.01-.08.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.73,45.74s0,0,0,0c0,.04,0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.42,44.53s-.02-.05-.04-.07c0,.02.02.04.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.42,44.43s.02.02.03.02c0-.04,0-.06-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.33,44.44s.04,0,.05.03c0-.01,0-.03,0-.03-.01,0-.02,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M172.11,45.79s0-.01,0-.02c-.04.09-.02.07,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "180.1 46.57 180.11 46.56 180.1 46.56 180.1 46.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.97,46.73c.07-.27.09-.23.13-.17v-.63s-.13.8-.13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M175.27,46.55l.07.2c-.12.31-.19.2-.12.48.05-.68.33-.05.38-.73l.05.15s-.02.03-.04.02c.09.33.11-.49.24-.38.05.05.08.16.04.23l.12-.16s.02.13-.01.12l.17-.04v.02c.03-.11.09-.27.12-.34.04.1-.02.07-.02.16l.1-.16c.03.18-.06.34-.12.32.05.68.09-.17.25.24l-.09.08c.04.39.11.25.2.5-.02-.13-.16-.62-.06-.78.03.05.06.08.12-.05-.01.24.04.18.11.17l-.02.32c.08-.09.08-.25.13-.39.08.04.08.28.09.49.12.06-.07-.4.09-.45.1.13.18,0,.32-.18.07.11-.02.19,0,.29l.08-.25s0,.08,0,.12c.06-.1.02-.32.11-.4.04-.35.15.52.28.13.02.09-.02.19-.02.32.16-.25.14-.18.28-.53l.09.22c-.06-.24.05-.52.15-.75-.02-.12-.04-.22-.05-.27l.15-.16c.01.05,0,.16-.04.29.01-.03.02-.05.03-.08.04.12,0,.3-.04.48-.01-.06-.03-.13-.04-.2-.04.19-.09.41-.09.59.01-.04.03-.07.05-.08-.01.05-.02.1-.02.13,0,.03.02-.04.05-.12v.36s.03-.14.03-.14l.17.23c.15-.35.29-.87.5-1.01-.06.26-.03.43-.05.73-.04-.33-.16.13-.26.06.05.04.03.18.02.23l.2-.29c-.02.25.03.19.07.3,0-.5.16-.33.24-.47,0,.17-.03.34-.12.29.08.38.16-.58.25-.25-.02,0-.03-.02-.05.06.06-.15.18-.02.15.12h-.02c.15.07.46.03.5-.39,0,.05-.05.51-.06.6l.35-1.41c-.04.36,0,1.24-.14,1.44.03.05.07.12.16,0-.02-.05-.03-.53,0-.56.07.41.05.22.15.57-.03-.08.04-.65.1-.63-.01.08-.03.56-.05.62l.17-.55c-.04.1-.03.48,0,.64,0-.11.12.02.17-.04l-.05-.13c.16.09.2-.78.36-.74-.03.11-.09.71,0,.79.05-.29.24-1.37.4-1.59l.02.17.12-.18c-.09.43-.33,1.33-.46,1.68.05.13,0,.19.1.18.02.16-.06.23-.09.24l.21.11c0-.34.18-.33.19-.61l-.25.34c0-.34.18-.95.33-.88.03.14-.06.6-.06.71.03-.11.15-.21.16-.13l-.07.18c.08.13.16-.44.24-.11.03.02.08.44.1.24-.04-.39.02-1.57.07-1.86.01.03.16.38.19.57.04.3-.12.71-.09.97,0-.09.04-.2.06-.24.03.08-.03.28.05.25.03-.34.16.04.05-.29.08-.09.08.07.17.06-.02-.22.12-.74.21-.84,0,.09,0,.2,0,.25.16.04.23.2.38.21,0,.08.07.19.04.33.02-.06.05-.17.1-.18.07.3-.1.04-.06.4.02-.2.13-.27.2-.39,0-.31-.15-.07-.22.05.02-.42.16-.86.32-1.04.13-.1.04.28.06.22.23.09.24-.73.41-.41.06.27-.03.53-.02.73-.1.1-.14-.18-.21-.17l.08.13c-.04.09-.11.15-.14.07.05.24.39.07.55.3.04-.09.1-.18.08-.29l-.06.03c-.04-.22.12-.29.06-.4.08-.15.18-.38.28-.25v.31c0-.09-.06-.19-.09-.09.05-.13.14.42.21.02l-.06-.22c.08-.15.2-.47.28-.37-.03-.3-.02.03-.07-.32.03.44-.24-.03-.17.44-.05-.41-.11-.18-.18-.54,0,.1.02.19-.05.14,0,.03-.02.07-.02.09,0,0,0,0,0,0,0,0,0,0,0,.01,0,.01,0,.02,0,0,.02.05.03.1.03.16-.05.23-.18.22-.23.33-.04-.05.03-.11,0-.22l-.07.18c0-.22-.1-.38.01-.5l-.1-.02c-.05-.13-.13-.18-.18-.09-.04-.05-.13.24-.08.07l-.16.13v-.06c-.15-.04-.34.35-.49-.06-.05.05-.11.12-.19.05v-.19c-.08.06-.2-.21-.24,0-.04-.53-.32-.13-.43-.23l-.02.25c-.08-.02-.16.05-.27.15v.22c-.1.18-.22-.17-.36-.16.01-.08.05-.06.07,0-.14-.51-.36.35-.49-.03-.04.08-.07.05-.09,0,0,0,0,0,0-.01,0,0,0,0-.02,0-.01-.04-.03-.09-.04-.12.01.06.02.1.04.12-.03,0-.07.03-.12.08v-.24s-.01,0-.02,0c-.04-.09-.04.11-.03.29-.02.04-.05.08-.06.14-.01-.39-.12.12-.14-.29-.04.2-.22.14-.27.56,0-.06,0-.08.01-.08-.04-.05-.09-.1-.14.02v-.31s-.13.41-.13.41c-.05-.19-.07-.3,0-.53-.17.35-.13.13-.28.48l.02-.2s-.13.27-.15.1c-.08-.38-.5-.08-.74-.44.02.58-.11-.27-.14.18,0-.14-.04-.22,0-.34-.14.13-.19-.23-.3.15,0-.14.04-.2.03-.28-.01.03-.05.12-.06.03s.03-.11.05-.17c-.14.02-.17.44-.21.84-.06-.19-.09-.17-.16.09-.02-.13-.05-.27.04-.31-.05-.02-.28-.21-.3.11-.01-.08-.06-.03-.08,0-.11-.02-.11-.05-.22-.03l.03.05c-.06.38-.09.08-.18.12v-.04c-.17-.29-.09.13-.26-.2v.24c-.05.51-.16-.31-.28-.12l.03.14c-.07.17-.13-.71-.19-.78-.01-.05.02-.07.04-.1-.14-.31-.04.31-.16.38-.01-.17.05-.43-.03-.46-.03-.14-.26.54-.35.21.02.13.03.26-.03.36-.09.04-.2-.51-.3-.1,0-.04-.01-.07,0-.1-.07.1-.22.16-.27.39-.01-.83-.42.38-.38-.38l-.2.03v-.08c-.11-.06-.17.12-.22.3-.03-.05,0-.12,0-.16-.18-.16-.2-.13-.37.24v-.25c-.05.14-.25-.4-.45-.12,0-.03,0-.08.03-.11-.22.28-.45-.71-.58.18l-.15.21c.17.08-.05.39.02.54-.07.05-.16-.28-.08-.32v.05c.07-.47-.2-.18-.18-.5-.35,0-.67-.27-.99-.31l.02.37-.11-.03c-.02-.09-.02-.29.06-.27-.03-.21-.14.17-.15.25-.15-.16.08-.42.04-.43l-.07.02v.04c-.05.15-.06.3-.16.28-.06-.08-.02-.23-.04-.24,0-.03,0-.04-.04-.01l-.14-.04.04.29c-.07.14-.13-.02-.08.31-.07-.51-.52-.21-.57-.37-.1.21-.19.2-.29.17.02.06.02.39-.07.34.07-.67-.15-.3-.2-.78.05.32-.27.06-.19.52-.07-.06,0-.25-.04-.41-.2.25-.4-.19-.63-.12,0,.09.02.22-.03.35l-.1-.45s-.07.5-.13.2c0,.07.02.19-.01.21-.42-.45-.93.3-1.34-.53.05.17.01.19-.04.19.03.04-.01.22-.01.34l-.17-.34c-.05.33-.2.01-.24.33l.06-.05c-.1.37.07.83.03,1.31.11-.42.2.64.38.04.03.1-.04.15-.02.26.05-.2.1-.24.17-.15v.05c.22-.04.31.17.57.32v-.24s.06.11.08.17c.08-.35-.16-.03-.08-.42.05.49.4.03.42.58.09,0-.01-.28.08-.27v.15s.05-.19.05-.19c.06.03.07.22.07.35-.01-.02-.04.03-.06.04.06.18.21-.05.23.01l-.08-.1c.24-.13.52.08.77-.2v-.11c.17-.2.12.13.32.05v.03c.04-.11.09-.16.14-.15-.06.13.08.26,0,.4.2-.21.1-.17.25-.58l.02.19c.05-.17.06-.25.16-.3-.09.15.05.29-.05.49.18.42.32-.39.38.2.12-.51-.16-.29-.1-.4-.03-.17.1-.38.16-.32.06.01.07.66.24.66-.02,0-.02.04-.04.03.05.13.13-.17.19.05.06-.31.1.02.13-.37l-.15.08c.09-.1.19-.56.32-.33-.02.08-.06.18-.09.24.03.12.08-.07.12.05-.03.4-.18.08-.29.37.03.17.19-.28.12.15.09-.54.16.08.29-.33l-.02.24s.06-.15.09-.14l-.07.3c.1-.26.16.24.25.1-.18,0-.02-.29-.09-.46.24-.31.09.63.34.53-.04.03-.12-.15-.06-.26.04.05.1.15.12.27.17-.04-.01-.25.07-.39.04.29.09-.11.16-.2v.24c.16.16.06-.5.22-.3l-.09.33.09-.08-.03.27c.11-.2.13-.14.22-.06-.01-.17.04-.44.12-.44.05.15-.04.23.07.2-.03.15-.07.34-.11.11,0,.08-.03.15-.04.23.05.17.15.05.19.05-.02-.01-.03-.02-.04-.06l.19-.32c.02.09,0,.16-.03.23.04-.02.07-.13.12-.15-.02.2-.03.4-.11.49l.17-.21c0,.09.07.24.05.31.08.12.24-.37.35-.21,0-.04.02-.07.05-.1.11.05.19.3.34.03l.06.35c.11-.07-.08-.45.1-.57.13-.11.03.3.07.4.07-.17.19-.53.29-.24-.04.06-.07.01-.1.03ZM176.55,46.47s-.09.2-.1.06c.04-.27.06-.14.1-.06ZM178.52,45.99c-.02.08-.05.04-.08-.06.02-.02.05,0,.08.06ZM184,44.61s0,0,0,.01c-.05-.1-.03-.06,0-.01ZM184.11,44.72s.01-.07.01-.1c-.01.06-.04.06-.07.04,0,.06.02.11.05.06ZM171.84,44.15l.02.06c-.05.07-.04,0-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M178.28,46.31s0-.09,0-.13c-.01.04-.01.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M174.48,46.64s0,0,0,0c0,.01,0,.03,0,.04v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.23,46.67s-.03-.08-.04-.13c0,.06,0,.11.04.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.73,44.34l-.08.06s.05.04.06.08c0-.06,0-.14.01-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M185.29,45.87s.02,0,.04-.03v-.11s-.08.09-.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.76,45.15c0,.2.04.14.1.1,0,0,0,0,0,0,.03-.28-.03-.19-.09-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.87,45.24s.03-.01.05,0c.01-.11-.02-.02-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.26,44.59c.02.05.03-.26.04-.18.04-.26-.18.3-.04.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "184.76 45.82 184.76 45.57 184.72 45.77 184.76 45.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.37,45.61l.08.07s.01-.07.03-.08c-.05-.01-.1-.06-.1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.47,45.6s.05,0,.07-.04c-.01,0-.05,0-.07.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "184.65 45.89 184.62 45.83 184.57 45.81 184.65 45.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.49,45.52l-.09.07c-.01.09,0,.14.04.11.02-.06.06-.09.05-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.72,46.22c-.02-.05-.02-.11-.03-.19l-.02.31.05-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.46,46.27c-.01.09-.14.24-.03.23.01-.08.11-.15.03-.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "182.13 45.81 182.16 45.81 182.18 45.3 182.13 45.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.88,46.96c.1.13.04-.31.13-.16.03-.12-.07-.13-.04-.23-.07.12-.1.05-.09.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.97,46.57s.02-.04.04-.08c-.02.03-.03.05-.04.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "167.7 43.66 167.63 43.55 167.67 43.73 167.7 43.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.55,44.03v-.32s-.06.29-.06.29c.02-.01.05-.04.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M176.71,47.13v-.08c0-.08-.01-.09-.04-.11l.04.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "175.8 46.84 175.81 46.85 175.8 46.55 175.8 46.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M175,47.17s.07-.05.1-.04c-.07.05-.09-.33-.1.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.9,7.21s-.19.02-.23.03c.05.01.28-.04.23-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "207.4 7.32 207.32 7.33 207.53 7.33 207.4 7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.43,7.51c.35-.08-.07-.06.05-.11l.08-.02-.29.03c.05.03.25.05.16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.69,7.74c.14-.03.12,0,.04-.03-.01,0-.02,0-.03.01,0,0,0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.69,7.72s-.11.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.79,7.8h-.13c-.08.01-.09.04-.15.04.07.01.15,0,.28-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.05,7.78h-.05s-.04,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.88,7.76h.11c.06,0,.17-.02-.04,0,.1-.02,0,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.93,7.74c.07-.03.12-.05.25-.05-.06-.04-.3,0-.25.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.8,7.46l.1-.04h-.12c.06,0-.09.06.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.63,7.99c.08-.01.2-.04.29-.06h-.09s-.09.04-.2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.93,7.93h.13s-.05-.02-.13,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "207.44 7.71 207.16 7.71 207.44 7.72 207.44 7.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "206.64 8.1 206.47 8.11 206.73 8.1 206.64 8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.68,8.17c-.15.01-.24.06-.33.06.03.02.16.01.27,0-.06,0-.05-.02.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.79,8.23s-.1,0-.17,0c.03,0,.08,0,.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.03,7.99s-.16.03-.21.06l.21-.05s0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.04,8h0s0,.02,0,.03c0,0,0-.01.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.03,7.99s0,0,0,0c.02,0,.03,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.26,7.82c.12,0,.25,0,.43-.06-.15.01-.25.05-.43.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.29,7.93l.04-.04c-.06.01-.14.03-.2.03h.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "207.36 7.93 207.29 7.93 207.28 7.94 207.36 7.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.98,8.14c.09,0,.1.01.12.02.04-.02.06-.05.05-.06-.07,0-.19.02-.18.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.02,8.07s0,0,.01,0c.02,0,.02,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.12,8.33s.03,0,.04,0c-.01,0-.02,0-.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.19,8.1s-.01-.02-.08-.02c.02,0,.04.01.04.02.03,0,.05,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.89,8.26s.08-.03.11-.04c-.07.02-.17.05-.11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.98,8.09s0,0,0,0c-.04.01-.02,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.98,8.09s.08,0,.13,0c-.02,0-.04,0-.07,0-.01,0-.04,0-.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.48,8.14c-.2.03-.38.03-.18-.04-.15,0-.79.13-1.14.21.09-.01.16-.03.28-.02.1-.03.24-.11.42-.11.11.02-.06.04-.16.08.24-.06.36-.01.72-.08h-.13c.06-.02.15-.03.2-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.17,8.26h-.03s-.11.04-.26.08c.1,0,.17,0,.24-.01l.02-.07h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.14,8.19c.21-.03.31-.01.54-.07-.02-.03-.18,0-.28,0,.06.05-.12,0-.23.07-.04,0-.05-.01-.06-.02-.02.01-.05.03-.09.05,0,0,0,0,.01,0h0s0,0,0,0c.03,0,.04-.01.03,0,0,0,0,0,0,0,.03,0,.06,0,.08-.01-.04.02-.05.01-.08.01-.01,0-.02,0-.03,0,0,0,0,0,0,0l.13.04s.02-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.15,7.72s-.03,0-.05.01c.03,0,.04,0,.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.02,7.76s-.12.01-.1,0c.06-.02.1-.02.17-.03-.06,0-.16,0-.26.04h.03c-.07.04-.33.11-.36.11.19-.04.32-.07.51-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.63,7.97l.11.03.18-.06-.11.02s-.1,0-.18,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "207.02 8.35 206.79 8.38 207.12 8.36 207.02 8.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "207.06 8.41 206.86 8.44 206.98 8.44 207.06 8.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M210.09,11.55h.06s-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M210.09,11.44h-.1c.05,0,.09,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.35,9.95c-.18.05-.46.12-.24.08l.21-.04s-.02-.02.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.81,10.79s.04-.01.06-.02c-.07,0-.14.01-.21.02.04,0,.09,0,.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M209.7,10.65l-.13.05s.09-.03.13-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M210.42,12.07l.22-.02s-.11,0-.22.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.25,9.04c-.08.03-.11.05-.12.07.12-.04.3-.09.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.82,11.9s.08,0,.13-.01c-.04,0-.08,0-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.14,9.16s.03-.01.05-.02c-.04,0-.07-.02-.06-.03-.09.03-.14.06,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M210.6,14.15s-.01,0-.02,0c.03,0,.03,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.54,15.12s-.02-.01-.02-.02c-.01,0-.01.01.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.01,8.68s-.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.84,8.47s.06,0,.1-.01c-.05,0-.08.01-.1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.49,9.06s0,0,0,0c.04-.01.03,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.1,8.64s-.05.02-.06.03c.02,0,.04-.01.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207,8.66s.01-.01.02-.02c-.04,0-.06,0-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.02,8.7s0-.02.02-.03c-.01,0-.03,0-.03,0,0,0,0,0,.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M209.83,13.15s-.01,0-.02,0c.09,0,.08,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "209.63 9.92 209.62 9.92 209.61 9.92 209.63 9.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M209.8,9.94c-.27.03-.24,0-.19-.02l-.61.12.8-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M210.2,11.78l.19-.07c.32-.01.22.03.48-.04-.67.11-.09-.12-.76,0l.14-.05s.03,0,.03,0c.31-.1-.49.05-.4-.02.05-.03.14-.06.22-.06h-.17s.13-.05.12-.03l-.06-.06h.02c-.11,0-.27.01-.34.01.09-.03.07,0,.16-.02h-.17c.17-.05.34-.05.32-.02.66-.15-.17,0,.2-.14l.09.02c.38-.09.23-.09.46-.17-.12.03-.58.18-.76.17.05-.02.07-.04-.07-.04.24-.04.18-.05.16-.08l.32-.05c-.1-.01-.26.02-.4.03.03-.04.27-.09.47-.13.04-.06-.39.1-.46.05.11-.06-.02-.07-.22-.09.1-.05.19-.03.28-.05l-.26.02s.08-.02.12-.02c-.1,0-.32.05-.41.03-.35.05.49-.16.09-.13.09-.03.19-.03.32-.05-.27-.01-.2-.02-.55,0l.2-.08c-.23.07-.52.08-.75.09-.11.03-.21.06-.26.07l-.18-.02c.05-.02.16-.03.29-.04-.03,0-.05,0-.08,0,.11-.04.3-.06.48-.08-.06.02-.13.04-.19.05.19-.02.41-.04.59-.08-.04,0-.07,0-.09,0,.05,0,.1-.01.13-.02.03,0-.04,0-.12,0l.35-.07-.14.02.21-.11c-.36.01-.89.06-1.05,0,.26-.02.42-.07.73-.12-.32.08.15.04.09.09.03-.03.18-.05.23-.05l-.31-.02c.25-.04.18-.05.28-.09-.49.1-.34,0-.49,0,.17-.03.34-.05.3,0,.36-.1-.59.05-.28-.05,0,0-.02.02.07,0-.15,0-.04-.07.1-.08h0c.05-.06-.03-.17-.45-.11.05-.01.51-.08.59-.09l-1.43.14c.36-.05,1.21-.24,1.42-.22.05-.02.11-.05-.03-.06-.05.02-.52.11-.55.11.39-.11.21-.06.54-.17-.07.03-.64.11-.63.08.08-.01.56-.1.62-.1l-.56.04c.1,0,.47-.08.62-.12-.11.02,0-.05-.06-.06l-.12.05c.07-.08-.79.07-.77,0,.12-.01.71-.1.77-.15-.29.03-1.38.17-1.6.15l.16-.04h-.19c.43-.06,1.34-.14,1.7-.16.12-.05.19-.04.17-.07.15-.04.23-.02.24-.01l.08-.1c-.33.06-.34,0-.62.04l.36.03c-.33.06-.95.11-.9.04.13-.04.59-.09.7-.11-.12.01-.23-.02-.15-.04h.18c.12-.06-.45.02-.14-.08.02-.02.42-.11.22-.08-.37.09-1.54.3-1.83.33.02,0,.35-.13.53-.18.29-.07.71-.09.96-.15-.09.01-.2.02-.24.02.07-.03.28-.04.23-.07-.34.05.02-.07-.29.03-.1-.01.06-.04.04-.08-.22.05-.74.1-.85.08.09-.01.2-.04.25-.05.02-.07.17-.13.16-.19.08-.02.17-.06.32-.08-.06,0-.18.01-.19,0,.28-.09.05.03.4-.05-.2.03-.28,0-.4,0-.3.06-.05.07.08.07-.42.07-.86.1-1.06.08-.11-.03.27-.07.2-.07.06-.1-.74.05-.45-.08.26-.08.53-.09.72-.13.11.02-.16.09-.14.11l.12-.05c.09,0,.16.01.09.04.23-.07.02-.16.23-.27-.09,0-.19,0-.29.03l.04.02c-.21.06-.3,0-.4.05-.16,0-.4,0-.28-.06l.3-.06c-.09.02-.17.06-.08.05-.14,0,.4-.14,0-.09l-.2.07c-.16,0-.48.01-.4-.04-.3.07.04,0-.31.09.43-.1,0,.1.45-.02-.4.1-.16.08-.5.17.1-.02.19-.05.14,0,.03,0,.07,0,.09,0,0,0,0,0,0,0h.01s.02,0,0,0c.04-.01.09-.03.15-.04.23-.02.23.03.35.02-.04.03-.12.01-.22.04h.18c-.22.04-.36.11-.5.09v.04c-.12.04-.17.09-.07.09-.04.03.25,0,.08.02l.15.04h-.06c-.02.08.39.07,0,.21.06.01.13.02.07.07l-.19.04c.07.01-.18.11.02.09-.51.12-.09.15-.17.21l.25-.04s.07.05.17.07l.22-.04c.19,0-.14.11-.11.17-.08.01-.07,0-.02-.03-.49.15.39.07.03.19.08,0,.06.02,0,.04,0,0,0,0-.01,0,0,0,0,0,0,0-.04.01-.08.03-.11.04.05-.02.1-.03.12-.04,0,.01.04.02.1.03l-.24.05s0,0,0,0c-.08.03.11,0,.29-.05.04,0,.09,0,.15,0-.38.08.14.02-.27.11.2-.02.16.06.58,0-.05.01-.08.02-.08.01-.04.03-.09.05.03.05l-.3.06.41-.03c-.18.06-.28.09-.52.1.37,0,.14.02.51.01l-.2.03s.28,0,.12.04c-.36.1-.02.21-.34.37.57-.12-.25.09.2.02-.13.03-.21.06-.33.06.14.03-.2.12.18.09-.14.03-.2.02-.28.04.03,0,.12,0,.04.02s-.12.01-.18.01c.03.05.45-.02.85-.08-.18.06-.15.07.11.04-.13.03-.26.07-.31.05-.02.02-.17.15.15.09-.08.02-.02.03.02.03-.01.05-.04.05,0,.09l.05-.02c.38-.05.09.02.14.05h-.04c-.26.13.14.02-.16.15l.24-.05c.51-.08-.29.12-.09.13l.13-.04c.18,0-.68.19-.74.22-.04.01-.07,0-.11,0-.29.12.31-.05.39-.01-.17.04-.43.06-.45.1-.13.04.56,0,.25.1.13-.03.25-.06.35-.06.05.03-.47.18-.06.13-.03.01-.07.02-.1.02.11,0,.19.05.41.03-.81.17.42.09-.33.22l.05.07h-.08c-.04.07.14.06.33.04-.05.02-.12.02-.16.03-.14.1-.11.1.28.1l-.24.05c.15,0-.36.17-.07.2-.03,0-.08.01-.11.01.3.03-.64.31.25.19l.23.02c.06-.08.39-.06.53-.11.06.02-.26.12-.31.09h.04c-.47.06-.15.1-.47.15.05.13-.19.31-.18.44l.36-.08v.05c-.09.03-.29.06-.28.03-.2.05.18.02.26.01-.14.09-.42.05-.43.07l.03.02h.04c.15-.02.31-.04.3,0-.07.04-.22.05-.23.06-.03,0-.04,0,0,.02l-.02.06.28-.07c.14,0,0,.06.31-.03-.49.12-.14.24-.29.29.21,0,.22.03.2.08.06-.02.38-.08.34-.04-.66.1-.27.12-.74.23.31-.08.1.09.54-.03-.05.04-.25.04-.4.09.27.03-.14.19-.04.26.09-.01.22-.05.35-.05l-.42.12s.5-.07.21.01c.07-.02.18-.04.21-.04-.39.25.41.3-.35.62.16-.05.18-.04.19-.02.04-.02.21-.04.33-.06l-.31.13c.33-.04.04.08.35.03h-.06c.37-.05.81-.2,1.28-.28-.42.04.6-.2,0-.16.09-.03.15-.02.26-.04-.21.02-.25,0-.17-.04h.05c-.07-.09.13-.16.24-.29l-.23.05s.1-.05.16-.07c-.36.04,0,.07-.4.11.47-.11-.02-.16.52-.27,0-.03-.27.06-.27.02l.14-.03-.19.02s.21-.07.33-.09c-.01,0,.04,0,.05.01.17-.06-.07-.07-.02-.09l-.08.05c-.15-.07.02-.22-.29-.26l-.11.03c-.22-.03.11-.08,0-.14h.03c-.11,0-.17,0-.16-.03.13,0,.24-.08.39-.08-.23-.04-.18,0-.6.01l.18-.04c-.17.01-.26.03-.31,0,.16,0,.27-.07.49-.07.39-.15-.42-.05.15-.19-.51.05-.27.12-.38.12-.16.05-.38.04-.34,0,0-.03.64-.16.62-.22,0,0,.04,0,.04,0,.12-.05-.18-.02.02-.08-.31.04.01-.04-.38.02l.1.04c-.11-.02-.57.03-.36-.06.08,0,.19-.01.25,0,.11-.04-.08-.02.03-.05.39-.06.1.06.4.04.16-.05-.29-.02.13-.07-.54.07.06-.07-.36-.05l.23-.04s-.15,0-.15,0l.31-.03c-.26,0,.21-.11.07-.12.02.07-.28.06-.44.12-.33-.03.6-.16.47-.23.04,0-.13.07-.24.07.04-.03.13-.07.25-.1-.06-.06-.24.05-.39.05.28-.07-.12-.01-.22-.02l.24-.04c.14-.1-.5.07-.33-.03l.33-.03-.09-.02.27-.04c-.21,0-.16-.02-.09-.07-.17.04-.43.07-.45.04.14-.05.23-.03.19-.07.15-.02.34-.04.12.02.08-.01.15-.02.23-.03.16-.05.03-.07.02-.08,0,0-.02.02-.05.03h-.34c.09-.04.16-.04.23-.04-.03,0-.14,0-.16-.02.19-.03.39-.06.49-.05l-.23-.03c.08-.02.22-.07.3-.08.11-.05-.39-.02-.25-.09-.04,0-.07,0-.1,0,.04-.05.27-.13,0-.14l.34-.09c-.09-.03-.43.12-.57.07-.12-.03.29-.07.39-.1-.18,0-.54.03-.27-.07.07,0,.02.02.05.03ZM209.96,11.31c.05,0,.21,0,.07.03-.27.04-.15,0-.07-.03ZM209.25,10.64c.08,0,.04.01-.04.04-.02,0-.01-.02.04-.04ZM207.23,8.79s0,0,.01,0c-.09.04-.05.02-.01,0ZM207.32,8.73s-.07,0-.1.01c.06,0,.07,0,.05.02.06-.01.1-.03.05-.03ZM208.26,13.57l.06-.02c.07,0,0,.01-.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M209.59,10.67s-.08.02-.13.03c.04,0,.09-.01.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M210.38,12.08s0,0,0,0c.01,0,.03,0,.04,0h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M209.46,9.08s-.08.03-.12.04c.06,0,.11-.02.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M206.88,8.56l.07.02s.04-.03.07-.04c-.06.01-.13.03-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.3,8.05s0,0-.04,0l-.11.02s.1.01.15-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.66,8.4c.2-.04.13-.04.09-.06,0,0,0,0,0,0-.28.04-.18.05-.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.74,8.33s-.02-.01,0-.02c-.11.02-.02.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M207.18,8.69s-.26.04-.18.02c-.26.03.32.01.18-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "208.32 8.27 208.07 8.32 208.27 8.29 208.32 8.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.16,8.46l.06-.04s-.07,0-.09,0c0,.02-.05.05.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.14,8.42s0-.02-.05-.02c0,0,.01.02.05.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "208.4 8.3 208.35 8.31 208.34 8.34 208.4 8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.18,8.81l.08.02c.09-.01.14-.03.1-.04-.06,0-.1,0-.18.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.83,8.59s-.1.03-.19.05l.31-.05h-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.92,8.68c.09-.01.25,0,.23-.03-.08.01-.16-.01-.23.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "208.63 9.28 208.62 9.27 208.12 9.36 208.63 9.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M209.91,9.54c.11-.06-.31.04-.17-.02-.12.01-.12.05-.22.06.13,0,.06.03.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M209.52,9.58s-.04,0-.08,0c.03,0,.06,0,.08,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "208.29 15.26 208.19 15.31 208.36 15.26 208.29 15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M208.67,15.25l-.32.06.29-.03s-.04-.01.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M210.59,11.12h-.08c-.08.03-.09.04-.1.05l.18-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "210.41 11.53 210.42 11.52 210.13 11.58 210.41 11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M210.83,11.77s-.06-.02-.05-.03c.06.02-.31.1.05.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.69,51.58s-.1-.16-.12-.2c0,.05.15.24.12.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "182.78 52.08 182.74 52.01 182.83 52.2 182.78 52.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.62,52.18c.21.29.03-.09.12,0l.05.07-.14-.25c0,.06.05.25-.03.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.12,51.58c.08.11.05.11.04.02,0-.01-.02-.02-.02-.03,0,0,0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.14,51.58s-.07-.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.11,51.7l-.04-.12c-.05-.07-.08-.07-.1-.12.01.07.06.14.15.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.23,51.93l-.02-.05s-.03-.04.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.17,51.77l.04.11s.1.14-.01-.04c.05.09,0,0-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.22,51.81c.05.06.1.09.14.21.02-.07-.12-.28-.14-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.81,52.5l.07.08-.05-.11c.02.05-.08-.06-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.87,51.62c.04.06.11.17.17.25l-.03-.08s-.08-.07-.14-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.04,51.87l.04.13s0-.06-.04-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "182.43 52.27 182.33 52.01 182.43 52.28 182.43 52.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.78 51.67 181.7 51.51 181.81 51.76 181.78 51.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.73,51.74c-.07-.13-.14-.2-.18-.28,0,.03.05.15.09.25-.02-.06,0-.06.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.71,51.86s-.04-.09-.06-.15c.01.03.03.08.06.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.02,51.99s-.09-.14-.13-.17l.12.18h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.02,52h0s-.03,0-.03,0c0,0,.01,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.03,51.99h0s.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.27,52.14c.05.11.09.24.21.37-.07-.13-.14-.21-.21-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.18,52.21l.05.03s-.08-.11-.1-.17l.05.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "182.2 52.28 182.18 52.21 182.16 52.2 182.2 52.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.86,52c.04.09.03.1.02.12.04.03.06.04.08.03-.03-.06-.09-.17-.1-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.95,52.02s0,0,0,.01c.01.01.02.02,0-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.75 52.2 181.77 52.23 181.75 52.2 181.75 52.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.99,52.18s.01-.02-.02-.08c0,.02,0,.04,0,.05.01.03.02.04.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.73,51.97s.06.06.08.09c-.04-.05-.11-.14-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.92,51.98h0s-.02-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.92,51.98s.03.08.05.12c0-.02,0-.04-.02-.07,0-.01-.02-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.41,53.4c-.1-.17-.16-.35-.03-.18-.05-.14-.41-.69-.62-.99.04.07.09.14.12.26.06.09.19.18.26.35.02.11-.06-.04-.14-.12.14.2.14.33.34.64l-.03-.13s.06.13.1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.83,52.22v-.03s-.08-.08-.18-.21c.03.09.07.16.1.22h.07s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.87,52.17c.1.19.13.28.26.47.02-.03-.07-.17-.1-.26-.02.08-.05-.11-.15-.19,0-.04,0-.05,0-.07-.02-.02-.05-.04-.08-.07h0s0,.01,0,.01h0s.03.04.01.03h0s.03.05.04.08c-.04-.03-.03-.05-.04-.07l-.02-.03h0s.01.13.01.13c.03.02.04,0,.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.7,52.93s-.02-.03-.03-.04c.01.02.02.04.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.61,52.83s-.05-.1-.03-.09c.04.05.05.09.09.15-.02-.05-.06-.15-.13-.22v.03s-.22-.26-.23-.29c.11.16.19.27.3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.27,52.55v.12s.13.15.13.15l-.06-.09s-.03-.09-.07-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.69 52.11 181.57 51.92 181.72 52.21 181.69 52.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.65 52.17 181.55 52 181.59 52.11 181.65 52.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.5,56.07v.06s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.61,56.03l-.04-.09c.02.05.03.09.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.3,52.96c-.11-.15-.26-.4-.15-.2l.11.19s.02-.02.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.93,54.61l.03.06c-.03-.07-.05-.13-.08-.19.01.04.03.09.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.31,55.42l-.09-.11s.06.08.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.03,56.52l.07.21s-.03-.11-.07-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.13,52.57c-.06-.06-.09-.09-.1-.09.08.1.19.25.1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M178.58,53.95s.02.08.04.12c0-.04-.02-.08-.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.98,52.5s.02.03.03.04c0-.04,0-.07.01-.07-.06-.07-.1-.11-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M176.9,57.17s0-.01-.01-.02c0,.03.01.03.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M175.59,55.31s.01-.02.02-.02c0-.01-.02,0-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.38,52.22s-.01-.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.87,52.92s.03.05.05.09c-.02-.05-.04-.08-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.52,53.75h0s.02.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.45,52.29s-.03-.04-.05-.05c.01.01.03.03.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.39,52.21s.02,0,.02.01c-.02-.03-.03-.05-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.37,52.24s.02,0,.03,0c0-.01-.02-.02-.02-.03,0,0,0,.01-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M177.79,56.21s0,0-.01-.02c.02.09.02.07.01.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.03 55.12 181.03 55.11 181.03 55.1 181.03 55.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.06,55.29c-.1-.25-.08-.23-.04-.18l-.3-.55.34.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.28,56.23l.11.16c.09.31.01.22.16.46-.27-.62.1-.12-.17-.74l.08.12s0,.03,0,.03c.18.28-.17-.46-.08-.4.04.04.09.12.12.2l-.03-.17s.06.11.05.11l.04-.08v.02c-.02-.1-.07-.26-.09-.33.06.08.02.07.06.14l-.03-.17c.09.15.13.32.09.31.32.6-.04-.17.2.16v.09c.19.34.15.2.29.4-.06-.11-.33-.51-.36-.68.03.04.06.06.02-.08.1.22.1.16.12.13l.13.29c-.01-.1-.08-.24-.13-.38.04.01.16.24.25.42.07.02-.2-.34-.17-.43.09.09.07-.04.03-.24.08.09.08.18.13.26l-.08-.24s.04.07.06.11c-.02-.1-.14-.29-.14-.38-.14-.32.29.43.16.05.05.08.08.18.14.29-.06-.26-.03-.2-.14-.54l.13.17c-.13-.2-.22-.48-.29-.7-.06-.1-.12-.19-.14-.23l-.03-.18s.07.15.12.27l-.02-.07c.07.1.14.27.21.43-.03-.05-.07-.11-.11-.17.07.18.16.38.24.55-.01-.03-.02-.07-.02-.09.02.05.04.09.05.12.02.03,0-.04-.04-.11l.17.31-.06-.13.17.17c-.11-.35-.3-.84-.3-1.01.1.24.19.38.33.66-.17-.28,0,.15-.07.11.04.02.1.16.12.2l-.06-.3c.11.23.1.16.17.25-.24-.44-.1-.32-.14-.48.08.15.15.31.1.29.21.32-.22-.55-.03-.28,0,0-.02-.01.01.07-.05-.14.05-.06.11.07h0c.08.03.17-.08-.01-.46.02.05.23.46.26.54l-.56-1.32c.16.33.6,1.08.64,1.29.04.04.08.08.05-.04-.03-.04-.27-.46-.27-.49.22.34.12.18.33.46-.05-.06-.3-.58-.27-.57.04.08.27.5.28.56l-.21-.53c.03.1.22.42.31.56-.06-.09.05-.02.04-.07l-.08-.1c.1.04-.31-.73-.24-.74.05.11.32.64.38.69-.12-.26-.59-1.25-.65-1.47l.09.14-.05-.19c.18.39.55,1.23.68,1.57.08.1.1.17.13.14.09.13.09.22.09.23l.13.04c-.16-.29-.1-.33-.24-.57l.08.35c-.16-.29-.4-.86-.32-.84.08.11.28.53.33.63-.05-.11-.05-.22,0-.15l.06.17c.09.09-.16-.42.03-.16.02.01.25.36.15.18-.21-.32-.78-1.36-.91-1.62.02.02.24.29.35.44.17.25.32.64.46.86-.04-.08-.09-.19-.1-.22.05.06.13.25.14.2-.16-.3.07,0-.13-.26-.02-.1.06.04.09.01-.12-.19-.34-.67-.36-.77.04.08.1.17.13.21.07,0,.18.11.23.08.05.07.12.14.18.27-.02-.06-.07-.16-.06-.18.18.24-.01.06.19.35-.1-.17-.09-.26-.13-.38-.16-.26-.08-.02-.05.1-.21-.37-.39-.77-.43-.97,0-.12.15.23.13.17.12.02-.3-.68-.08-.45.16.22.27.46.37.63.02.11-.14-.12-.16-.09l.09.09c.03.08.04.16,0,.1.14.2.16-.04.34.11-.03-.08-.06-.18-.13-.26v.04c-.13-.18-.12-.28-.19-.35-.05-.15-.14-.37-.04-.29l.16.26c-.05-.08-.12-.14-.08-.06-.05-.13.27.32.08-.03l-.13-.17c-.05-.15-.19-.45-.11-.38-.17-.25.01.03-.19-.26.25.37-.09.03.18.41-.23-.34-.13-.13-.34-.41.05.09.11.16.06.13.01.03.03.06.04.08h0s0,0,0,0c0,.01,0,.02,0,0,.03.03.06.08.09.12.1.21.06.23.1.34-.04-.03-.05-.1-.12-.19l.07.17c-.12-.19-.23-.3-.26-.43h-.04c-.08-.09-.14-.11-.11-.02-.04-.03.08.24,0,.08l.02.15-.03-.05c-.07,0,.08.39-.19.07.01.06.03.13-.04.09l-.1-.17c.01.07-.16-.13-.08.05-.28-.44-.17-.04-.25-.1l.12.22s-.03.08-.01.19l.11.2c.06.18-.15-.1-.19-.05-.04-.08-.01-.06.02-.02-.3-.41.05.39-.17.09.03.08,0,.06-.03.01,0,0,0,0,0-.01h0s-.05-.07-.07-.1c.03.04.06.08.07.1,0,0,0,.04,0,.1l-.12-.21h0c-.06-.06.04.11.13.27.01.04.03.08.05.14-.19-.34.02.14-.19-.22.08.18,0,.17.19.56-.03-.05-.04-.07-.04-.08-.04-.03-.08-.07-.04.05l-.15-.27.15.38c-.11-.15-.17-.25-.25-.47.11.35.02.14.14.49l-.09-.18s.08.26,0,.12c-.21-.32-.21.05-.46-.22.28.51-.16-.21.04.19-.07-.12-.11-.18-.15-.3.01.14-.17-.16-.03.2-.07-.12-.08-.19-.12-.26,0,.03.04.11,0,.04s-.04-.11-.06-.16c-.04.04.15.43.32.79-.11-.16-.11-.13-.01.12-.07-.11-.14-.23-.13-.29-.03,0-.19-.12-.05.17-.04-.07-.03,0-.02.03-.05,0-.06-.02-.09.02l.03.04c.15.35,0,.09,0,.15l-.02-.04c-.19-.22.03.14-.18-.12l.11.21c.21.47-.19-.25-.15-.05l.07.12c.05.17-.36-.61-.41-.65-.02-.04-.02-.07-.03-.1-.19-.25.13.29.11.37-.08-.15-.17-.4-.21-.41-.07-.12.15.54-.03.26.06.11.13.23.15.33-.01.06-.29-.41-.15-.02l-.05-.09c.02.11,0,.2.07.41-.36-.75.02.43-.29-.26l-.06.07-.03-.07c-.07-.03,0,.15.05.32-.03-.04-.05-.11-.07-.15-.13-.11-.12-.08-.03.3l-.1-.22c.04.14-.25-.31-.21-.02-.01-.03-.03-.07-.04-.11.04.3-.45-.56-.13.29l.04.23c.09.04.14.37.23.49,0,.06-.17-.22-.16-.28l.02.04c-.17-.44-.15-.12-.27-.42-.12.07-.34-.11-.47-.09l.15.33h-.05c-.04-.08-.12-.26-.08-.26-.09-.19.01.18.04.26-.11-.11-.13-.41-.15-.41v.04s0,.04,0,.04c.04.15.09.29.05.29-.05-.06-.09-.21-.11-.22,0-.02-.02-.03-.02,0h-.06s.13.25.13.25c.03.14-.06,0,.09.3-.22-.46-.26-.09-.34-.23.04.21,0,.22-.04.21.03.05.15.35.1.33-.22-.63-.17-.25-.36-.69.14.29-.07.11.12.52-.05-.04-.09-.23-.17-.37.02.27-.21-.1-.27.01.03.08.09.2.11.33l-.19-.4s.15.48.02.21c.03.07.07.17.07.2-.31-.34-.24.45-.67-.25.08.15.07.18.05.19.02.03.07.21.11.32l-.18-.29c.09.32-.07.05.02.35v-.06c.09.36.31.77.46,1.23-.1-.41.29.56.16-.03.04.09.04.15.08.25-.05-.2-.05-.25.02-.17v.05c.09-.08.2.1.35.19l-.09-.22s.06.09.09.14c-.09-.35-.07,0-.18-.38.19.44.16-.05.36.46.04,0-.1-.25-.07-.26l.06.14-.06-.18s.11.19.15.31c-.01-.01,0,.04,0,.05.09.15.06-.09.09-.04l-.06-.07c.05-.16.23-.02.22-.34l-.05-.1c0-.22.1.09.14-.02v.03c-.02-.11-.02-.17,0-.17.03.13.13.22.15.37,0-.24-.02-.18-.12-.58l.08.17c-.04-.16-.07-.25-.05-.31.03.16.12.25.17.46.23.35-.03-.43.22.11-.15-.49-.17-.24-.19-.35-.08-.15-.11-.37-.07-.33.03,0,.28.6.34.56,0,0,0,.04,0,.04.07.11-.02-.18.09,0-.1-.3.04,0-.1-.37l-.02.11c0-.11-.14-.55,0-.36.03.08.05.18.06.24.06.1,0-.08.06.02.14.37-.04.11.04.4.08.15-.04-.29.1.11-.18-.52.09.04-.02-.36l.09.22s-.03-.15-.02-.15l.09.29c-.06-.26.15.19.13.04-.07.04-.12-.26-.22-.41-.03-.33.28.55.34.41,0,.04-.1-.11-.12-.22.04.04.1.11.15.22.05-.07-.1-.22-.13-.37.13.26-.01-.12-.02-.22l.09.22c.13.11-.17-.47-.04-.33l.1.32v-.09s.1.26.1.26c-.04-.2,0-.16.06-.1-.07-.15-.16-.41-.13-.43.08.12.08.22.11.17.05.14.11.32,0,.13.03.07.05.14.08.22.09.14.08,0,.09,0-.01,0-.02-.01-.04-.04l-.06-.34c.05.08.07.15.09.22,0-.03-.03-.14-.02-.16.07.18.15.37.16.47l-.02-.23c.04.08.12.2.15.27.08.09-.06-.39.04-.27-.01-.04-.02-.07-.02-.1.06.02.2.23.14-.04l.17.31c0-.09-.22-.39-.2-.54,0-.12.14.27.2.35-.05-.17-.15-.52,0-.28.01.07-.02.02-.02.05ZM179.71,55.87c.01.05.06.2,0,.08-.11-.26-.04-.14,0-.08ZM180.2,54.99c.03.07,0,.04-.05-.03,0-.02.01-.02.05.03ZM181.35,52.46h0c-.07-.06-.04-.03,0,0ZM181.44,52.53s-.03-.06-.05-.09c.03.05.02.06,0,.05.04.05.06.09.05.03ZM177.06,54.76l.03.06c0,.07-.01.01-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.26,55.32s-.04-.08-.06-.12c.01.04.03.08.06.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "179.02 56.49 179.02 56.48 179.03 56.52 179.02 56.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.82,54.67s-.05-.06-.08-.1c.03.05.06.09.08.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.44,52.05v.07s.04.03.07.05c-.03-.05-.08-.12-.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.43,53.2s0,0,0-.04l-.06-.1s.02.1.06.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.88,52.73c.11.17.09.1.09.06h0c-.14-.24-.11-.15-.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.96,52.78s0-.02.01-.01c-.06-.1-.02-.02-.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.43,52.39s-.13-.23-.08-.16c-.12-.23.1.3.08.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "182.23 53.29 182.1 53.08 182.19 53.26 182.23 53.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182,53.22l.06.04s-.03-.06-.04-.08c-.02,0-.07-.03-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.02,53.19s.02-.01,0-.05c0,0-.01.02,0,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "182.23 53.38 182.2 53.34 182.17 53.34 182.23 53.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.66,53.36v.08c.04.08.08.12.07.08-.02-.06-.03-.09-.07-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.1,53.9s-.06-.09-.11-.16l.15.27-.04-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.04,54.02c.04.08.08.24.11.2-.04-.08-.04-.16-.11-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.36 53.95 181.36 53.94 181.12 53.5 181.36 53.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.5,55.26c.1.09-.14-.28-.03-.17-.05-.11-.09-.09-.13-.19.04.12-.01.07.16.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.34,54.9s-.01-.04-.02-.07c.01.03.02.05.02.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "175.41 55.08 175.35 54.99 175.42 55.14 175.41 55.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M175.48,55.45l-.11-.31.08.28s0-.05.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.06,56.42l-.03-.07c-.04-.07-.05-.08-.07-.08l.1.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "179.6 56.37 179.61 56.37 179.47 56.11 179.6 56.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M179.44,56.85s0-.06.02-.06c0,.06-.17-.28-.02.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M161.46,28.81s-.05.18-.06.22c.03-.04.08-.27.06-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "161.79 28.4 161.77 28.48 161.85 28.28 161.79 28.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162,28.45c.07-.35-.09.04-.09-.09v-.08s-.07.27-.07.27c.05-.03.16-.2.16-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M161.92,29.23c.03-.14.05-.11-.01-.05,0,.02,0,.02,0,.04,0,0,.01,0,.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M161.9,29.21s-.01.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.01,29.16l-.06.11c-.01.08,0,.11-.02.16.04-.06.06-.14.07-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.1,28.91l-.03.05s0,.05.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.02,29.06l.06-.1c0-.06.04-.17-.02.04.03-.1,0,0-.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.02,29c0-.08,0-.13.05-.24-.06.03-.12.28-.05.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.09,28.09v-.11s-.04.11-.04.11c.02-.06.02.1.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.14,29.38c.02-.07.04-.2.06-.29l-.04.08c0,.05,0,.1-.02.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.2,29.09l.06-.12s-.04.04-.06.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "162.2 28.53 162.09 28.78 162.22 28.53 162.2 28.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "162.25 29.42 162.19 29.59 162.29 29.34 162.25 29.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.34,29.41c-.05.14-.04.24-.08.33.03-.02.08-.14.12-.24-.03.06-.05.04-.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.44,29.34s-.04.09-.07.15c.02-.03.04-.07.07-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.31,29.02s-.03.16-.03.22l.04-.21h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.32,29.02h0s.02.02.02.02c0,0,0-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.3,29.02h0s0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.24,28.74c.05-.11.12-.23.12-.41-.05.14-.05.24-.12.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.36,28.75l-.02-.06c-.01.05-.03.14-.05.19l.07-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "162.39 28.69 162.36 28.75 162.36 28.77 162.39 28.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.44,29.13c.04-.09.05-.09.08-.1,0-.05-.02-.07-.04-.08-.02.06-.06.18-.04.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.39,29.06s0,0,0-.01c0-.02,0-.02,0,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "162.68 29.08 162.69 29.04 162.68 29.08 162.68 29.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.48,28.92s-.02,0-.05.07c.02-.02.03-.03.04-.03,0-.03.01-.05,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.51,29.26s0-.08,0-.12c0,.07-.02.17,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.38,29.11h0c0,.05,0,.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.38,29.11s.03-.08.05-.12c-.01.01-.03.03-.04.06,0,.01,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.09,27.77c-.05.19-.14.36-.12.14-.07.14-.22.77-.28,1.13.02-.08.04-.16.11-.26.02-.11,0-.26.07-.43.07-.09.02.08,0,.18.05-.24.15-.33.23-.68l-.07.11c.01-.05.05-.14.05-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.63,29.01l-.02.02s0,.12-.02.27c.05-.09.07-.16.09-.22l-.06-.04v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.56,29.01c.06-.21.12-.29.16-.52-.04,0-.07.17-.12.25.08-.04-.05.11-.03.24-.02.03-.04.04-.05.05,0,.03,0,.06,0,.1h0s0-.01,0-.01h0s0-.05,0-.03h0s.02-.06.02-.08c0,.05-.01.05-.02.08v.03s0,0,0,0l.09-.1s-.02-.03-.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.51,27.88s0,.03-.01.05c.01-.02.02-.04.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.5,28.02s-.04.11-.05.09c0-.07.03-.1.04-.17-.02.05-.07.14-.07.25v-.03c.02.08-.01.35-.03.37.04-.19.07-.33.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.55,28.46l.08-.09.02-.19-.03.11c-.02-.05-.05.08-.07.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "162.66 29.19 162.59 29.4 162.71 29.1 162.66 29.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "162.73 29.18 162.68 29.37 162.73 29.26 162.73 29.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.32,28.43l.04-.04s-.03.03-.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.23,28.37l-.05.09s.05-.08.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M164.28,29.65c-.05.18-.13.45-.05.25l.07-.2s-.03,0-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.84,28.94l.02-.06c-.04.06-.08.12-.11.18.03-.04.05-.07.08-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.27,28.15l-.04.14s.03-.09.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.94,28.48l.11-.19s-.06.1-.11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.41,29.29c0,.09,0,.12,0,.14.02-.13.05-.31,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.22,30.46s.05-.07.07-.11c-.03.03-.05.06-.07.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.47,29.44s0-.03,0-.05c-.02.03-.05.05-.06.04-.01.09-.01.15.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M169.56,29.09s0,.01,0,.03c0-.03,0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M170.46,31.17s-.02.02-.03.02c0,.01.02,0,.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.97,29.34s0,.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.13,28.5s.02-.05.03-.1c-.02.05-.03.08-.03.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M164.02,28.2h0s0-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.97,29.24s0,.05,0,.07c0-.02,0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.95,29.34s0-.02,0-.02c-.01.03-.02.06,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.99,29.33s-.01-.01-.02-.03c0,.01,0,.03,0,.03,0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M168.53,29.52s0,.01,0,.02c.04-.08.03-.07,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "165.5 27.72 165.49 27.73 165.49 27.73 165.5 27.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.62,27.59c-.13.24-.13.2-.13.14l-.23.58.36-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.58,28.5l.06-.19c.18-.27.16-.16.25-.42-.31.61-.15,0-.46.61l.04-.14s.02-.03.02-.02c.11-.31-.25.42-.26.31,0-.06.04-.15.09-.22l-.12.13s.05-.12.06-.1h-.09s0,0,0,0c-.06.09-.16.22-.2.28.03-.09.04-.06.08-.14l-.11.13c.07-.16.18-.3.19-.26.28-.62-.11.14,0-.25l.07-.06c.16-.35.07-.24.14-.47-.05.12-.21.57-.33.7.01-.05.01-.08-.08.03.11-.21.06-.17.03-.17l.15-.28c-.07.07-.15.21-.23.33-.02-.04.09-.27.18-.45-.03-.07-.15.37-.24.39.01-.13-.08-.03-.22.11.02-.11.1-.17.13-.26l-.15.21s.04-.08.05-.11c-.07.08-.15.28-.23.34-.17.31.17-.49-.06-.16.03-.09.1-.17.15-.28-.18.2-.14.14-.35.43l.05-.21c-.08.23-.25.46-.39.65-.04.11-.08.2-.1.25l-.13.13c.02-.05.07-.15.14-.26l-.04.06c.03-.11.13-.27.22-.43-.02.06-.05.12-.07.19.1-.17.21-.35.3-.52-.02.03-.04.06-.06.07.03-.04.05-.09.06-.11.01-.03-.02.03-.07.1l.15-.32-.07.12.03-.24c-.22.29-.5.74-.64.83.14-.22.19-.38.33-.66-.12.31.13-.09.14-.01,0-.04.06-.17.09-.22l-.21.23c.11-.23.07-.18.09-.28-.2.46-.21.27-.3.39.07-.15.15-.3.18-.25.12-.36-.31.5-.22.19.01,0,0,.03.05-.05-.09.12-.09,0-.02-.14h.01c-.04-.08-.2-.09-.38.29.02-.05.22-.46.26-.54l-.69,1.26c.16-.33.46-1.15.6-1.31,0-.05,0-.12-.08-.02,0,.05-.18.5-.21.52.12-.39.06-.21.14-.55-.01.08-.25.6-.27.57.04-.08.21-.52.25-.57l-.28.49c.05-.09.18-.44.23-.59-.03.1-.05-.03-.09.01l-.02.13c-.04-.11-.36.71-.42.65.05-.11.28-.66.27-.74-.12.26-.57,1.26-.7,1.45l.05-.16-.11.16c.17-.4.58-1.22.75-1.53.02-.13.06-.18.01-.19.04-.15.11-.21.12-.21l-.06-.13c-.11.32-.19.29-.29.55l.23-.29c-.11.32-.39.87-.44.79.03-.13.22-.56.25-.66-.05.11-.14.18-.12.1l.09-.16c0-.13-.21.4-.15.08,0-.03.1-.43.03-.24-.1.37-.49,1.49-.6,1.76,0-.03.05-.37.09-.56.07-.29.27-.67.33-.92-.03.09-.08.19-.1.22,0-.08.1-.27.05-.24-.12.32-.06-.05-.11.27-.07.08-.01-.08-.06-.08-.06.21-.27.7-.33.78.03-.08.06-.19.07-.24-.06-.05-.05-.21-.11-.23.02-.08.02-.19.07-.32-.03.05-.07.16-.09.16.05-.29.06-.03.13-.38-.06.19-.13.24-.2.35-.08.29.05.08.11-.03-.13.4-.31.81-.43.98-.08.09.06-.27.03-.21-.08-.1-.29.68-.28.37.04-.27.15-.51.2-.7.07-.09.02.18.05.18v-.13c.04-.08.09-.14.08-.06.04-.24-.15-.09-.17-.33-.04.08-.09.17-.11.27l.03-.03c-.04.21-.13.28-.12.38-.07.14-.17.36-.19.23l.07-.3c-.02.09-.02.18.02.1-.05.13.04-.42-.09-.04l-.02.21c-.07.14-.2.44-.21.34-.06.3.02-.03-.05.32.09-.43.09.04.18-.41-.08.4,0,.18-.06.53.03-.1.04-.19.06-.13.01-.03.02-.06.03-.08h0s0,0,0,0c0-.01,0-.02,0,0,0-.04.01-.1.02-.15.08-.22.13-.2.18-.31,0,.05-.04.11-.06.22l.08-.17c-.06.22-.05.37-.13.49l.04.02c-.01.13,0,.18.05.1,0,.05.12-.22.05-.06l.1-.11-.02.05c.05.04.24-.32.19.09.04-.05.08-.11.09-.04l-.05.19c.05-.06.02.21.09.02-.14.51.09.15.1.25l.08-.24s.08-.03.15-.12l.07-.21c.1-.16.03.18.09.18-.03.08-.04.05-.03,0-.11.5.26-.3.19.07.04-.07.04-.04.03.02,0,0,0,0,0,0h0s-.02.09-.02.12c.01-.05.02-.1.03-.12.01,0,.04-.02.08-.07l-.08.23h0c-.02.08.05-.11.11-.28.02-.03.05-.07.08-.13-.13.37.09-.1-.05.29.09-.18.14-.11.31-.5-.02.05-.03.08-.04.08,0,.05,0,.1.06,0l-.11.29.2-.36c-.05.18-.08.29-.2.49.2-.31.1-.11.29-.41l-.08.18s.16-.23.1-.07c-.12.36.17.14.12.5.24-.53-.07.26.13-.15-.06.13-.08.2-.15.3.11-.1-.02.23.18-.09-.06.13-.1.17-.13.25.02-.02.07-.1.04-.02-.03.08-.06.1-.09.15.06,0,.26-.37.44-.72-.06.18-.03.16.1-.06-.05.12-.1.25-.15.27,0,.03.02.23.17-.05-.03.07.01.03.04,0,.03.04.02.07.08.06v-.05c.21-.33.09-.06.14-.08l-.02.03c-.05.29.1-.1.02.22l.11-.21c.25-.45-.08.3.06.15l.05-.13c.11-.14-.26.66-.27.73-.02.04-.04.06-.07.08-.08.3.16-.27.24-.31-.07.15-.21.37-.2.42-.05.13.35-.44.24-.13.05-.12.1-.24.17-.32.06-.02-.13.49.09.14-.01.03-.03.07-.04.09.08-.08.17-.11.29-.3-.35.75.35-.27,0,.41h.1s-.04.07-.04.07c.03.07.13-.08.23-.24-.01.05-.05.11-.07.15.01.18.04.15.27-.16l-.1.23c.08-.12-.04.41.16.18-.01.03-.03.07-.05.1.2-.23-.03.73.34-.09l.15-.18c-.05-.1.16-.36.18-.51.05-.04-.02.28-.08.31v-.04c-.17.43.05.19-.07.49.17.04.25.34.41.41l.08-.36.05.04c0,.09-.06.28-.09.25-.04.21.12-.15.14-.22.04.16-.14.4-.12.42l.04-.02v-.04c.07-.14.11-.29.16-.26.01.08-.04.22-.03.24,0,.03,0,.04.02.02l.07.05.04-.29c.07-.13.06.03.11-.3-.07.5.23.23.23.39.08-.2.12-.19.17-.16,0-.06.04-.38.07-.34-.11.66.04.3.03.78,0-.32.15-.06.14-.52.03.06-.02.25,0,.41.12-.25.21.19.36.1,0-.09-.02-.22.01-.35l.07.44s.02-.51.07-.2c0-.07-.02-.19,0-.21.29.42.43-.38.84.35-.07-.16-.05-.18-.03-.19-.03-.04-.05-.21-.08-.33l.18.3c-.06-.33.11-.05.03-.36l-.02.06c-.07-.37-.28-.78-.39-1.25.07.42-.22-.59-.13.01-.03-.09-.02-.15-.05-.26.03.2.02.25-.02.16v-.05c-.07.06-.14-.13-.23-.26l.03.24s-.03-.1-.04-.16c0,.36.05.02.07.41-.06-.48-.14,0-.18-.54-.03,0,.02.27-.01.27v-.15s-.01.19-.01.19c-.02-.03-.03-.22-.03-.34,0,.01.01-.03.02-.05-.02-.18-.06.06-.07,0l.02.09c-.08.14-.15-.06-.26.23v.11c-.09.2-.04-.13-.12-.04v-.03c-.02.11-.05.16-.07.15.04-.13,0-.26.05-.4-.1.21-.06.17-.17.57l.02-.18c-.05.16-.06.25-.11.29.06-.15.03-.28.1-.48.01-.41-.19.38-.1-.21-.15.49,0,.29-.04.4-.02.17-.11.37-.13.31-.02-.02.11-.65.05-.65,0,0,.01-.03.02-.03.01-.13-.09.16-.06-.05-.1.3-.03-.03-.14.35l.08-.07c-.06.09-.21.53-.21.3.03-.08.07-.17.1-.22.02-.12-.05.07-.03-.05.12-.38.09-.06.2-.35.03-.16-.14.26,0-.15-.17.52-.03-.08-.19.31l.07-.23s-.06.14-.07.13l.11-.29c-.11.24.01-.24-.06-.11.06.01-.08.28-.1.45-.18.28.15-.6.03-.52.02-.03,0,.15-.06.25,0-.05,0-.15.04-.27-.07.03-.07.23-.15.36.08-.28-.07.1-.13.18l.08-.23c0-.17-.2.46-.19.26l.15-.3-.06.07.11-.25c-.11.18-.1.12-.1.04-.06.16-.17.4-.2.4.03-.14.1-.21.04-.19.07-.14.15-.31.08-.09.03-.07.06-.14.1-.21.04-.16-.04-.06-.05-.06,0,.01,0,.03,0,.06l-.19.28c.03-.09.06-.15.1-.21-.02.02-.07.12-.1.13.08-.18.16-.36.22-.44l-.14.17c.03-.08.07-.23.1-.29.02-.12-.23.31-.21.15-.02.03-.04.06-.06.09-.02-.06.05-.29-.12-.07l.13-.33c-.07.05-.16.42-.28.51-.09.08.12-.28.14-.37-.1.15-.3.45-.21.17.04-.05.03,0,.06-.02ZM167.03,28.39s.12-.17.07-.04c-.14.24-.09.12-.07.04ZM165.98,28.49c.04-.07.04-.03,0,.06-.02.01-.03,0,0-.06ZM163.17,29.19h0c0,.09,0,.05,0,0ZM163.15,29.08s-.02.06-.03.1c.02-.06.03-.06.04-.04.01-.06.02-.11,0-.06ZM168.27,31.13v-.06c.05-.06.02,0,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M166.22,28.24s-.04.08-.06.12c.02-.03.04-.08.06-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "167.92 28.52 167.92 28.52 167.94 28.48 167.92 28.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M164.52,27.37s0,.08-.02.12c.02-.06.03-.1.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.8,29.41l.05-.05s0-.04,0-.08c-.01.05-.03.13-.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.92,27.89s-.01,0-.02.03l-.03.11s.06-.09.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.98,28.62c.05-.2.01-.14-.02-.1h0c-.08.27-.03.19.01.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M162.96,28.53s-.02.01-.02,0c-.03.11,0,.03.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.06,29.19c0-.05-.08.25-.06.17-.08.25.15-.28.06-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "163.14 27.98 163.08 28.22 163.15 28.03 163.14 27.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.27,28.2l-.02-.08s-.02.06-.03.08c.02.01.03.07.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.22,28.2s-.02,0-.04.03c0,0,.02,0,.04-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "163.21 27.92 163.21 27.97 163.23 27.99 163.21 27.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.63,28.36l.06-.06c.03-.08.03-.13,0-.11-.03.05-.05.08-.07.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.71,27.66c0,.05-.02.11-.04.19l.09-.3-.05.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M163.84,27.63c.03-.08.13-.22.07-.22-.03.08-.09.14-.07.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "164.31 28.19 164.3 28.19 164.13 28.68 164.31 28.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.26,27.25c0-.13-.13.29-.12.13-.06.11,0,.13-.06.22.08-.11.06-.03.17-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M165.09,27.6s-.02.04-.04.07c.02-.03.03-.05.04-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "170.68 31.4 170.75 31.49 170.68 31.33 170.68 31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M170.65,31.02l.1.31-.06-.29s-.01.05-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.26,27.77l-.04.07c-.04.08-.03.09-.03.1l.06-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "167.5 28.17 167.49 28.16 167.37 28.43 167.5 28.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M167.94,27.97s-.05.04-.05.02c.05-.04-.1.31.05-.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.15,3.66s-.14.13-.16.16c.04-.03.2-.2.16-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "180.55 3.39 180.49 3.45 180.65 3.31 180.55 3.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.61,3.45c.25-.26-.06.02.02-.08l.06-.06-.21.2s.2-.14.14-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.1,4.03c.1-.1.09-.08.02-.04-.01.01-.02.02-.02.03,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.1,4.01s-.08.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.18,3.99l-.1.08c-.06.06-.06.08-.11.12.06-.04.11-.1.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.37,3.81l-.04.03s-.03.03.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.24,3.91l.09-.07s.12-.12-.03.02c.08-.07,0,0-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.28,3.87c.05-.06.08-.1.17-.18-.05.02-.23.2-.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.87,3.19l.07-.08-.09.08s-.06.08.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.1,4.17c.05-.05.14-.14.21-.21l-.07.06s-.06.08-.14.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.31,3.95l.1-.08s-.04.02-.1.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "180.65 3.53 180.45 3.71 180.66 3.53 180.65 3.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "180.13 4.21 180 4.33 180.19 4.15 180.13 4.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.17,4.21c-.1.1-.17.17-.24.24.02-.01.12-.09.2-.17-.05.04-.04.02.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.26,4.17s-.07.06-.12.11c.03-.02.06-.05.12-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.4,3.91s-.12.12-.15.16l.15-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.4,3.91h0s0,.02,0,.02c0,0,0,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.4,3.91h0s.02-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.54,3.69c.09-.08.19-.16.31-.3-.11.1-.18.18-.31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.58,3.72l.02-.04s-.1.1-.14.14l.12-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "180.64 3.68 180.58 3.72 180.57 3.73 180.64 3.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.39,4.01c.07-.06.08-.06.1-.07.02-.03.04-.06.03-.06-.05.05-.14.13-.13.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.41,3.95h0s.02-.03,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "180.53 4 180.56 3.97 180.53 4 180.53 4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.54,3.86s-.01,0-.06.04c.02-.01.03-.02.04-.02.02-.02.04-.03.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.34,4.11s.05-.06.08-.09c-.05.05-.12.13-.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.38,3.99h0s-.02.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.38,3.99s.06-.05.1-.09l-.06.04s-.03.03-.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.53,3.06c-.14.14-.29.25-.14.1-.12.09-.58.55-.83.82.06-.06.12-.12.21-.19.07-.08.16-.2.3-.31.09-.06-.04.06-.11.14.17-.18.27-.23.53-.49l-.1.08s.11-.1.14-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.55,3.94h-.02s-.07.1-.18.21c.08-.06.13-.11.18-.16v-.04s.02-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.52,3.93c.16-.15.23-.2.39-.37-.02,0-.14.12-.21.18.06-.02-.09.08-.17.18-.03.02-.04.03-.05.03-.02.02-.04.05-.06.08h0s0,0,0,0h0s.03-.03.02-.02h0s.04-.04.06-.06c-.03.04-.04.04-.06.06l-.02.02h0s.1-.06.1-.06c.02-.02,0-.03-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.19,3.08s-.02.02-.04.04c.02-.02.03-.03.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.11,3.18s-.09.08-.07.06c.04-.05.07-.07.12-.12-.04.04-.12.1-.19.18l.02-.02c-.04.06-.23.26-.25.28.13-.14.23-.24.36-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.85,3.52l.09-.06.12-.14-.08.08s-.07.06-.14.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "180.46 4.07 180.29 4.23 180.53 4.02 180.46 4.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "180.5 4.08 180.35 4.21 180.44 4.13 180.5 4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.44,3.67l.05-.03-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.42,3.63l-.08.06s.08-.06.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.98,4.56c-.13.13-.34.33-.17.18l.16-.15s-.02,0,.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.28,4.07l.05-.05c-.06.05-.11.09-.16.13.04-.03.07-.06.11-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.96,3.48l-.1.1.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.79,3.74l.18-.13s-.09.07-.18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.75,4.23c-.06.06-.08.09-.08.1.08-.09.21-.23.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.66,5.14s.07-.05.1-.08c-.03.02-.06.05-.1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.69,4.35s.02-.02.03-.04c-.03.02-.06.04-.05.02-.06.07-.1.11.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.28,4.66s-.01,0-.02.02c.02-.02.02-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.7,6.19s-.02,0-.02,0c-.01.01,0,.01.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.51,4.22s-.02.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.1,3.61s.04-.04.08-.07c-.04.04-.06.06-.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.71,3.47h0s.02-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.57,4.15s-.03.04-.04.05c.01-.01.02-.03.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.5,4.22s0-.01.01-.02c-.03.02-.04.04-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.52,4.22s0,0,0-.02c-.01.01-.02.02-.02.02,0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.5,4.58s0,0-.02.01c.07-.05.06-.04.02-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "182.76 3.17 182.76 3.18 182.75 3.19 182.76 3.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.9,3.08c-.21.17-.19.15-.15.1l-.46.42.61-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.57,3.73l.14-.14c.26-.19.18-.11.38-.29-.52.43-.1,0-.62.43l.1-.1s.03-.02.02-.01c.24-.23-.39.3-.33.22.03-.04.1-.11.17-.16l-.14.09s.1-.09.09-.07h-.06s.02,0,.02,0c-.09.06-.22.16-.27.2.07-.07.06-.04.12-.1l-.14.09c.13-.12.27-.22.26-.19.51-.45-.14.1.14-.18l.08-.04c.29-.26.17-.18.34-.35-.09.09-.44.42-.58.52.04-.04.05-.06-.06.02.18-.16.13-.13.11-.13l.24-.21c-.08.05-.2.16-.32.24.01-.03.2-.2.36-.33.02-.05-.29.27-.36.29.08-.1-.03-.02-.19.08.07-.08.15-.13.22-.19l-.2.16s.06-.06.09-.08c-.08.06-.24.21-.32.25-.27.23.37-.36.05-.12.07-.06.15-.13.24-.21-.22.15-.16.11-.44.32l.15-.15c-.17.17-.4.34-.58.48-.08.08-.16.15-.19.18l-.15.09s.12-.11.23-.19l-.06.05c.08-.08.23-.2.36-.32-.05.04-.09.09-.14.14.15-.12.31-.26.46-.38-.03.02-.06.04-.07.05.04-.03.08-.06.1-.09.02-.02-.03.02-.09.07l.26-.24-.11.09.15-.17c-.29.22-.7.55-.83.62.2-.17.32-.28.55-.49-.24.22.12-.07.09-.01.02-.03.13-.13.17-.16l-.25.17c.19-.17.14-.13.21-.21-.37.34-.27.2-.39.29.12-.11.26-.22.24-.18.27-.26-.46.37-.23.14,0,0-.01.02.05-.04-.12.09-.05,0,.07-.1h0c.03-.06-.06-.07-.38.21.04-.04.39-.34.45-.4l-1.1.92c.27-.24.91-.84,1.08-.96.03-.04.07-.09-.03-.01-.04.04-.38.36-.41.38.29-.29.15-.16.4-.4-.05.06-.48.44-.48.42.06-.06.42-.38.47-.42l-.44.36c.08-.06.35-.32.47-.43-.08.08,0-.02-.06,0l-.09.1c.04-.08-.61.51-.6.47.09-.08.53-.47.58-.53-.22.19-1.04.91-1.22,1.04l.12-.11-.15.11c.33-.28,1.03-.87,1.3-1.1.09-.1.14-.13.12-.14.11-.11.18-.15.19-.15l.05-.1c-.25.23-.27.2-.48.4l.29-.2c-.25.23-.72.63-.7.57.1-.09.44-.4.53-.48-.09.08-.18.13-.12.07l.14-.11c.08-.1-.35.28-.12.05.01-.02.3-.31.16-.17-.28.26-1.15,1.07-1.36,1.27.02-.02.25-.27.38-.41.22-.2.53-.48.72-.66-.07.06-.16.13-.18.16.05-.06.21-.19.17-.17-.25.23,0-.04-.22.19-.08.06.04-.06.02-.06-.16.15-.56.5-.64.56.06-.06.14-.14.18-.17,0-.04.1-.16.09-.18.06-.06.12-.14.23-.23-.05.04-.13.11-.15.11.2-.21.05-.02.3-.27-.14.14-.21.17-.31.25-.22.21-.02.06.08-.01-.31.29-.64.58-.8.69-.09.06.19-.19.15-.16.02-.08-.56.48-.36.25.19-.2.39-.37.52-.51.09-.06-.1.14-.09.14l.08-.1c.07-.06.13-.1.07-.04.17-.18-.02-.08.12-.26-.07.06-.14.12-.22.19l.03-.02c-.15.16-.23.19-.29.27-.12.1-.3.25-.23.15l.22-.22c-.06.06-.12.14-.05.07-.1.09.28-.31-.02-.04l-.14.16c-.12.1-.37.31-.31.23-.21.22.02-.02-.22.23.31-.31.02.04.34-.29-.29.29-.11.14-.35.39.07-.07.14-.14.11-.09.02-.02.05-.04.07-.06h0s0,0,0,0c.01-.01.01-.01,0,0,.03-.03.07-.07.11-.11.17-.16.18-.13.27-.21-.03.04-.09.08-.16.16l.14-.12c-.16.16-.25.27-.36.35v.02c-.08.09-.11.14-.03.08-.03.04.19-.16.06-.04l.12-.08-.04.04s.31-.21.04.09c.05-.03.1-.07.07-.02l-.14.14c.06-.04-.12.16.03.02-.37.37-.05.12-.1.2l.19-.17s.06-.02.15-.08l.16-.15c.15-.11-.09.14-.06.14-.06.06-.05.04-.02,0-.35.36.31-.2.06.06.06-.05.05-.03,0,.01,0,0,0,0,0,0h0s-.06.06-.08.09c.04-.04.07-.07.08-.09,0,0,.03-.01.08-.04l-.18.16h0c-.06.06.09-.08.22-.2.03-.02.07-.05.11-.09-.28.27.11-.07-.19.21.15-.13.14-.07.46-.36-.04.04-.06.06-.06.06-.03.04-.06.08.03,0l-.23.21.32-.26c-.13.13-.21.21-.39.36.29-.22.11-.08.4-.3l-.15.13s.22-.17.1-.05c-.27.26.02.1-.21.37.43-.39-.18.19.16-.11-.1.09-.16.15-.25.22.12-.07-.14.17.16-.07-.1.09-.15.13-.21.19.02-.02.09-.07.03-.02-.06.06-.09.07-.14.11.03,0,.35-.28.66-.54-.13.13-.11.12.09-.04-.1.09-.19.18-.24.2,0,.02-.11.16.13-.04-.06.06-.01.02.02,0,0,.03-.02.05.01.04l.04-.04c.3-.25.08-.04.12-.06l-.03.03c-.19.21.11-.08-.11.16l.18-.16c.39-.33-.21.22-.05.11l.1-.09c.14-.11-.51.48-.56.53-.03.03-.06.04-.08.06-.21.22.24-.2.31-.23-.13.11-.33.28-.35.31-.1.09.45-.32.21-.1.1-.09.19-.18.28-.23.05-.02-.35.35-.03.09l-.08.07c.09-.06.16-.08.33-.22-.63.54.36-.2-.23.29h.05s-.06.05-.06.05c-.02.05.12-.06.27-.17-.04.04-.09.08-.12.1-.1.12-.07.11.24-.11l-.19.16c.12-.09-.27.28-.03.13-.02.02-.06.05-.09.07.25-.15-.48.5.23-.06l.19-.12c.03-.07.31-.24.42-.35.05-.02-.19.2-.24.21l.03-.03c-.37.29-.1.14-.35.34.06.03-.11.24-.09.3l.28-.23v.03c-.07.06-.22.18-.22.16-.16.13.15-.09.21-.14-.1.11-.34.26-.34.27h.03s.03-.04.03-.04c.12-.08.25-.18.25-.16-.05.05-.17.14-.18.16-.02.02-.03.02,0,.01v.04s.21-.19.21-.19c.12-.08,0,.03.25-.18-.39.32-.08.19-.2.29.18-.12.18-.1.17-.07.04-.04.3-.24.28-.2-.53.4-.21.2-.59.51.25-.2.09-.01.44-.3-.03.04-.2.15-.32.26.23-.13-.09.16,0,.14.07-.05.17-.14.28-.21l-.34.28s.41-.3.18-.1c.06-.05.15-.12.17-.13-.29.32.38-.08-.22.47.13-.11.15-.11.16-.11.03-.03.17-.13.27-.2l-.25.22c.27-.19.04.02.3-.17l-.05.02c.31-.21.66-.51,1.04-.79-.35.24.48-.41-.03-.07.07-.06.13-.09.21-.16-.17.12-.21.13-.14.07l.04-.03c-.07,0,.08-.14.16-.26l-.19.14s.08-.07.12-.11c-.3.21,0,.04-.32.26.38-.3-.04-.07.39-.4,0-.02-.22.17-.22.15l.12-.09-.16.11s.16-.14.26-.22c-.01.01.03-.01.04-.02.13-.12-.07,0-.03-.04l-.06.07c-.14.05-.02-.12-.28.03l-.09.07c-.18.1.08-.1-.02-.07l.02-.02c-.09.06-.14.09-.14.07.11-.07.19-.17.31-.25-.2.11-.15.09-.49.33l.14-.12c-.14.1-.21.15-.26.16.14-.09.22-.18.39-.3.3-.28-.36.21.1-.17-.42.3-.2.2-.3.26-.13.11-.31.22-.28.18,0-.02.5-.42.48-.44l.03-.02c.1-.09-.15.09,0-.05-.25.19,0-.03-.31.22l.09-.03c-.09.05-.46.33-.3.17.07-.05.15-.11.2-.14.09-.08-.07.04.02-.04.31-.24.09-.03.34-.2.13-.11-.25.15.1-.11-.44.33.03-.07-.31.17l.19-.15s-.12.08-.12.08l.25-.18c-.22.15.16-.17.04-.09.03.02-.22.18-.35.3-.28.16.47-.41.35-.37.03-.02-.1.11-.19.17.03-.04.1-.1.19-.19-.06,0-.19.16-.31.24.22-.19-.1.06-.18.11l.19-.15c.1-.13-.4.31-.27.17l.27-.2-.08.04.22-.17c-.17.11-.13.08-.08.01-.13.11-.34.27-.36.27.1-.1.18-.14.14-.14.12-.09.27-.21.1-.06.06-.05.12-.09.18-.14.12-.11.01-.05,0-.05,0,0-.01.02-.04.04l-.28.18c.07-.06.13-.1.18-.15-.02.01-.11.08-.14.08.15-.12.31-.25.39-.3l-.19.11c.06-.06.17-.16.23-.2.08-.09-.32.21-.22.09-.03.02-.06.04-.08.06.02-.04.19-.21-.03-.06l.26-.24c-.07.03-.33.3-.45.36-.1.05.23-.2.3-.27-.14.1-.43.32-.23.12.06-.04.02,0,.04-.01ZM183.29,3.64s.17-.12.06-.03c-.21.17-.12.09-.06.03ZM182.6,3.73c.06-.05.04-.02-.03.04-.02,0-.01,0,.03-.04ZM180.69,4.13h0c-.06.06-.04.04,0,0ZM180.75,4.05l-.07.07s.05-.04.04-.03c.04-.04.07-.08.03-.04ZM182.26,5.64l.05-.04c.06-.04,0,0-.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.88,3.55s-.06.06-.1.09c.03-.03.07-.06.1-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "183.76 3.77 183.76 3.77 183.79 3.74 183.76 3.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.47,2.88s-.05.06-.09.09c.04-.04.08-.08.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.38,4.25l.05-.03s.02-.03.05-.06c-.04.04-.1.1-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.38,3.13s0,0-.03.02l-.08.08s.08-.06.11-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.95,3.69c.15-.14.09-.1.06-.08h0c-.21.2-.13.14-.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181,3.61s-.01,0,0,0c-.08.08-.01.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M180.64,4.12s-.19.18-.13.12c-.19.18.25-.2.13-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.43 3.22 181.25 3.39 181.4 3.26 181.43 3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.35,3.4l.04-.06s-.05.04-.06.06c0,.01-.03.05.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.32,3.4s0,0-.04.02c0,0,.01,0,.04-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.5 3.18 181.46 3.22 181.46 3.24 181.5 3.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.42,3.55l.06-.04c.06-.06.1-.1.07-.08-.05.04-.07.06-.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.89,3.04s-.08.08-.13.14l.23-.21-.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M181.97,3.03c.06-.06.2-.15.17-.15-.06.06-.13.09-.17.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "181.86 3.48 181.86 3.48 181.48 3.83 181.86 3.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.91,2.83c.08-.1-.24.21-.14.09-.09.08-.08.09-.16.16.1-.08.05-.02.3-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.62,3.08s-.04.03-.06.05c.03-.02.04-.03.06-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "182.5 6.39 182.42 6.46 182.56 6.35 182.5 6.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M182.82,6.18l-.26.19.24-.17s-.04.02.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M183.76,3.19l-.06.05c-.06.06-.07.06-.07.08l.13-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "183.69 3.48 183.7 3.48 183.47 3.67 183.69 3.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M184.08,3.36s-.05.02-.04.01c.05-.02-.24.22.04-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.59.61s-.18.07-.21.09c.05,0,.26-.11.21-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "194.08 .55 194.01 .58 194.2 .51 194.08 .55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.13.67c.32-.16-.07-.02.03-.1l.07-.04-.27.11c.05,0,.24-.04.16.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.46,1.05c.12-.06.12-.04.03-.03-.01,0-.02.01-.03.02,0,0,0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.46,1.04s-.1.06,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.56,1.07l-.12.03c-.07.04-.08.06-.14.08.07-.01.14-.05.26-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.8.97h-.05s-.04.04.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.64,1.01l.11-.03c.05-.03.16-.07-.04,0,.1-.04,0,0-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.69.98c.07-.04.11-.07.23-.11-.06-.01-.29.1-.23.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.47.53l.09-.06-.11.04c.06-.02-.08.06.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.44,1.25c.07-.03.18-.09.27-.13l-.08.02s-.08.06-.19.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.71,1.12l.13-.03s-.05,0-.13.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "194.17 .81 193.9 .9 194.17 .82 194.17 .81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "193.46 1.32 193.29 1.38 193.54 1.29 193.46 1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.51,1.36c-.14.05-.22.11-.31.14.03,0,.15-.04.25-.07-.06.02-.05,0,.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.61,1.37s-.09.03-.16.05c.03,0,.08-.02.16-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.81,1.13s-.15.07-.19.1l.19-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.82,1.14h0s0,.02,0,.02c0,0,0,0,.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.81,1.13h0s.02-.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.01.94c.11-.04.24-.07.4-.16-.14.05-.23.11-.4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.05,1.01l.04-.04c-.05.02-.12.06-.18.08l.15-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "194.12 .99 194.05 1.01 194.04 1.02 194.12 .99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.78,1.26c.09-.03.1-.02.12-.02.03-.03.05-.05.04-.06-.06.03-.17.07-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.82,1.19h.01s.02-.01-.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "193.94 1.34 193.98 1.33 193.94 1.34 193.94 1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.98,1.16s-.02,0-.08.01c.02,0,.04,0,.04,0,.03-.01.05-.02.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.72,1.36s.07-.04.1-.06c-.06.03-.15.08-.1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.78,1.21h0s-.02.01,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.78,1.21s.08-.03.12-.04c-.02,0-.04,0-.07.01-.01,0-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.21.82c-.18.08-.36.13-.17.02-.14.04-.73.32-1.06.49.08-.03.15-.07.27-.09.1-.05.21-.15.38-.2.1-.02-.05.05-.15.11.22-.11.34-.11.67-.27l-.13.03c.05-.02.14-.05.18-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.98,1.28h-.03s-.1.06-.23.14c.09-.03.16-.05.22-.08v-.05s.04,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.94,1.25c.2-.08.29-.1.5-.21-.02-.02-.17.06-.26.08.07.02-.11.04-.21.12-.04,0-.05,0-.06,0-.02.02-.05.04-.08.06h.01s0,0,0,0h0s.04-.02.02-.01h0s.05-.02.08-.03c-.04.03-.05.02-.08.03h-.03s0,.01,0,.01h.12s.01-.04-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.84.61s-.03.02-.05.02c.03,0,.04-.01.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.73.68s-.11.04-.09.02c.06-.03.09-.04.16-.07-.05.02-.15.04-.24.1h.03c-.06.04-.3.17-.33.18.17-.09.3-.15.47-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.38.94h.11s.16-.1.16-.1l-.1.05s-.09.02-.17.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "193.85 1.39 193.64 1.48 193.94 1.37 193.85 1.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "193.89 1.42 193.71 1.5 193.82 1.46 193.89 1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.17,2.81h.06s-.06,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.15,2.73l-.09.04c.05-.02.09-.03.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.35,2.44c-.16.09-.42.22-.22.13l.2-.09s-.02-.01.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.85,2.62l.06-.03c-.07.03-.13.05-.19.07.04-.01.09-.03.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.67,2.28l-.12.07s.08-.05.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.54,3.09l.21-.08s-.11.03-.21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.15,1.82c-.07.05-.1.07-.11.08.11-.06.27-.15.11-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.04,3.69s.08-.02.12-.04c-.04,0-.08.02-.12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.06,1.93s.03-.02.04-.03c-.04,0-.07,0-.06,0-.08.05-.13.08.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.97,4.54s-.01,0-.02.01c.03-.01.03-.01.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.12,5.77s-.02,0-.02,0c-.01,0,0,.01.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.88,1.63s-.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.64,1.24s.05-.02.1-.04c-.05.02-.08.03-.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.33,1.48h0s.03-.02,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.96,1.58s-.04.03-.05.04c.01,0,.03-.02.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.87,1.62s.01-.01.02-.02c-.03.01-.05.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.89,1.64s0-.01.01-.02c-.01,0-.02.01-.03.02,0,0,0,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.12,4.03s-.01,0-.02,0c.09-.03.07-.02.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "196.52 1.77 196.51 1.77 196.5 1.77 196.52 1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.68,1.73c-.25.09-.23.07-.18.04l-.57.26.75-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.29,2.95l.17-.1c.31-.1.21-.04.46-.17-.63.26-.1-.06-.73.2l.12-.07s.03,0,.03,0c.29-.16-.46.17-.39.1.04-.03.13-.08.21-.1l-.17.04s.12-.06.11-.04l-.07-.02h.02c-.1.03-.26.08-.33.1.08-.05.07-.02.15-.06l-.16.04c.16-.08.32-.13.31-.1.61-.29-.17.05.18-.16h.09c.35-.18.21-.14.42-.26-.11.06-.53.29-.7.33.04-.03.06-.05-.07,0,.22-.1.16-.09.14-.1l.29-.13c-.09.02-.24.08-.38.13.02-.03.25-.14.44-.22.03-.05-.35.18-.43.16.1-.08-.03-.04-.22,0,.09-.06.18-.07.26-.12l-.24.08s.08-.04.11-.05c-.1.02-.29.13-.38.14-.33.13.45-.25.07-.12.08-.04.18-.07.29-.13-.26.07-.19.04-.53.15l.18-.11c-.21.12-.48.2-.71.27-.1.05-.19.1-.24.12l-.17.03s.15-.07.27-.11l-.07.02c.1-.06.27-.13.44-.19-.06.03-.12.06-.18.09.18-.07.38-.15.55-.22-.04.01-.07.02-.08.02.05-.02.09-.04.12-.05.03-.01-.04,0-.11.04l.32-.15-.13.05.18-.14c-.34.11-.84.29-1,.3.25-.09.39-.17.68-.29-.29.15.15-.01.1.04.03-.03.16-.08.21-.1l-.29.07c.23-.1.17-.09.26-.14-.46.21-.32.1-.47.14.15-.07.31-.13.29-.09.33-.18-.55.2-.27.05,0,0-.02.02.06-.01-.14.05-.05-.04.09-.09h0c.04-.06-.05-.12-.44.05.05-.02.47-.2.55-.23l-1.34.5c.34-.14,1.12-.51,1.33-.56.04-.03.09-.07-.03-.03-.04.03-.48.23-.51.23.36-.19.19-.1.5-.27-.07.04-.6.26-.59.24.08-.03.52-.22.57-.25l-.53.19c.1-.03.44-.19.58-.26-.1.05,0-.04-.06-.02l-.11.07c.06-.08-.74.28-.73.22.11-.04.66-.27.72-.32-.27.11-1.29.51-1.51.57l.15-.07-.18.05c.41-.15,1.26-.47,1.6-.59.11-.07.18-.08.15-.1.14-.07.22-.08.23-.08l.07-.1c-.31.14-.33.09-.58.21l.35-.08c-.31.14-.89.35-.85.29.12-.06.55-.23.65-.28-.11.04-.22.05-.15.01l.17-.06c.11-.07-.42.14-.14-.01.02-.02.38-.2.2-.12-.34.17-1.43.65-1.7.76.02-.01.31-.2.48-.28.27-.14.67-.27.9-.38-.09.03-.19.07-.23.09.07-.04.26-.11.21-.11-.31.13,0-.05-.27.11-.1.02.05-.05.03-.07-.2.1-.69.28-.79.3.08-.04.18-.09.23-.11.01-.05.14-.14.13-.18.07-.04.16-.1.29-.15-.06.02-.17.06-.18.05.26-.14.05,0,.37-.15-.18.08-.26.08-.38.11-.28.13-.04.06.08.03-.39.17-.8.32-1,.36-.11.01.24-.12.19-.11.04-.09-.7.25-.44.07.24-.13.49-.22.66-.3.1-.01-.14.11-.12.12l.11-.07c.09-.03.15-.04.09,0,.21-.11,0-.12.18-.26-.09.03-.18.05-.27.1h.04c-.19.1-.29.09-.37.15-.15.04-.38.12-.28.04l.28-.13c-.08.04-.16.09-.07.06-.13.04.36-.21-.01-.06l-.19.11c-.15.04-.46.15-.38.09-.27.13.03,0-.28.15.4-.2.01.07.42-.14-.37.19-.15.1-.46.27.09-.04.17-.09.14-.05.03-.01.06-.02.08-.03h0s.01,0,.01,0c.01,0,.02,0,0,0,.04-.02.09-.05.14-.07.22-.08.22-.05.34-.09-.04.03-.11.04-.2.09l.17-.06c-.2.09-.33.18-.46.21v.03c-.11.07-.14.11-.05.08-.04.03.24-.07.08,0l.15-.02-.05.02c0,.05.38-.07.03.14.06,0,.13-.02.08.03l-.18.08c.07-.01-.16.13.03.06-.47.23-.07.13-.14.2l.23-.1s.07.02.17,0l.2-.09c.18-.05-.12.12-.08.15-.08.03-.06.01-.02-.01-.44.25.38-.06.06.13.08-.02.06,0,0,.02,0,0,0,0-.01,0h0s-.07.05-.1.07c.05-.03.09-.05.1-.06,0,0,.04,0,.09,0l-.22.1h0c-.08.05.11-.04.27-.12.04-.01.08-.03.14-.04-.35.17.13-.02-.24.16.19-.07.16,0,.56-.17-.05.02-.07.04-.08.03-.04.03-.08.06.04.03l-.28.13.39-.14c-.16.09-.26.14-.48.22.35-.11.14-.02.48-.13l-.18.08s.26-.08.12,0c-.33.18,0,.15-.28.36.53-.25-.23.14.19-.04-.12.06-.19.1-.31.14.14-.02-.18.14.18.01-.13.05-.19.08-.26.11.03,0,.11-.04.04,0s-.11.04-.17.06c.04.03.43-.14.79-.3-.17.09-.14.09.11,0-.12.06-.24.12-.29.12-.01.02-.14.15.15.03-.07.04-.01.03.02.02,0,.04-.03.05,0,.07l.04-.03c.36-.14.09-.01.14,0l-.04.02c-.23.16.13-.03-.14.15l.22-.1c.48-.2-.26.17-.07.12l.12-.06c.17-.05-.62.32-.68.36-.04.02-.07.02-.1.03-.26.16.29-.12.37-.12-.15.07-.4.16-.42.2-.12.06.53-.16.25,0,.12-.06.23-.12.33-.14.05,0-.43.26-.04.11l-.09.04c.1-.02.19-.01.4-.09-.75.34.42-.05-.29.25l.06.04-.07.03c-.03.05.14,0,.31-.07-.04.03-.11.05-.15.07-.12.11-.09.1.28,0l-.23.1c.14-.05-.33.22-.04.16-.03,0-.07.03-.1.04.29-.06-.58.4.26.06l.22-.05c.04-.07.36-.15.49-.22.06,0-.23.15-.28.15l.04-.02c-.44.18-.13.12-.42.25.06.08-.14.27-.12.36l.33-.15v.04c-.08.04-.27.12-.26.09-.19.09.18-.03.25-.06-.12.1-.4.15-.4.17h.03s.04-.01.04-.01c.14-.04.29-.1.28-.07-.06.04-.2.1-.21.11-.02.01-.03.02,0,.01v.05s.25-.13.25-.13c.14-.04,0,.04.29-.1-.45.22-.11.21-.24.29.2-.06.21-.03.2,0,.05-.03.35-.16.32-.12-.62.25-.25.16-.68.36.29-.14.1.04.51-.16-.04.04-.23.1-.37.17.26-.05-.11.17,0,.2.08-.03.2-.09.33-.13l-.39.2s.47-.18.2-.05c.07-.03.17-.08.2-.08-.34.28.43.1-.26.53.15-.08.17-.08.18-.07.03-.02.2-.08.31-.13l-.28.18c.31-.12.04.04.34-.07h-.06c.35-.12.75-.34,1.2-.52-.4.14.55-.3-.02-.11.09-.05.15-.05.25-.1-.19.07-.24.07-.16.02l.05-.02c-.07-.04.1-.15.2-.27l-.22.1s.09-.06.14-.09c-.34.12,0,.05-.37.19.44-.21-.04-.11.46-.33,0-.02-.25.11-.26.09l.13-.06-.18.07s.19-.11.31-.16c-.01,0,.04,0,.05,0,.15-.09-.08-.03-.03-.06l-.07.06c-.15,0,0-.16-.31-.11l-.1.05c-.21.03.1-.08-.01-.1h.03c-.11.02-.16.03-.16.01.13-.04.22-.12.37-.16-.23.04-.17.04-.57.17l.17-.08c-.16.05-.24.09-.3.08.16-.04.25-.13.46-.18.35-.21-.41.08.12-.17-.48.17-.24.16-.35.19-.15.08-.36.13-.32.09,0-.02.59-.28.56-.32,0,0,.04,0,.04,0,.11-.07-.18.04.01-.06-.29.11,0-.03-.36.12h.1c-.1.02-.54.18-.35.06.07-.03.18-.06.23-.07.1-.06-.08,0,.03-.05.37-.15.1.01.39-.08.15-.08-.28.07.12-.09-.51.2.04-.07-.35.06l.22-.09s-.14.04-.14.03l.29-.1c-.25.08.19-.13.05-.1.03.04-.26.12-.41.21-.32.07.56-.28.42-.3.03,0-.12.09-.22.12.04-.03.12-.08.23-.14-.06-.02-.22.1-.36.14.26-.13-.12.02-.21.04l.22-.09c.12-.11-.47.18-.32.07l.32-.11h-.09s.25-.09.25-.09c-.2.05-.15.03-.09-.03-.15.07-.4.17-.42.15.13-.07.21-.08.17-.1.14-.05.32-.12.12-.02.07-.03.14-.05.21-.08.14-.08.02-.06.01-.07,0,0-.02.02-.05.03l-.33.09c.08-.04.15-.07.22-.09-.03,0-.13.04-.16.03.18-.07.37-.15.46-.17l-.22.04c.08-.04.21-.11.27-.14.1-.07-.38.09-.25,0-.04.01-.07.02-.1.03.03-.05.24-.17-.02-.1l.31-.16c-.09,0-.4.2-.54.21-.12.01.27-.13.36-.18-.17.05-.51.17-.26.03.06-.02.02.01.05.01ZM197,2.67s.2-.06.07,0c-.26.1-.14.04-.07,0ZM196.25,2.39c.08-.03.04,0-.04.04-.02,0-.02,0,.04-.04ZM194.1,1.65h.01c-.08.05-.05.03-.01,0ZM194.18,1.57s-.06.02-.09.04c.06-.02.06-.02.05,0,.06-.03.1-.05.04-.04ZM195.66,4.75l.06-.03c.07-.01.01,0-.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.58,2.32s-.08.04-.12.05c.04-.01.08-.03.12-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "197.5 3.11 197.5 3.11 197.54 3.09 197.5 3.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.25,1.21s-.07.04-.11.06c.05-.02.1-.05.11-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M193.74,1.58h.07s.03-.04.06-.06c-.05.02-.12.06-.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.03.81s0,0-.03,0l-.1.05s.1-.02.14-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.46,1.24c.19-.08.12-.07.08-.07h0c-.26.11-.17.09-.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.53,1.17s-.02,0,0-.01c-.1.04-.02.01,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.04,1.59s-.24.1-.16.06c-.24.1.3-.08.16-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "195.07 .95 194.84 1.06 195.03 .99 195.07 .95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.95,1.14l.05-.05s-.06.02-.08.03c0,.02-.04.05.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M194.92,1.11s0-.01-.05,0c0,0,.02,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "195.15 .95 195.1 .98 195.09 1 195.15 .95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195,1.39h.08c.08-.04.12-.07.09-.06-.06.02-.09.02-.17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.6,1.04s-.1.05-.17.09l.28-.13-.11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M195.69,1.08c.08-.03.24-.07.21-.09-.08.03-.15.04-.21.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "195.49 1.59 195.48 1.59 195.02 1.79 195.49 1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.74,1.42c.1-.08-.29.12-.16.03-.11.04-.1.07-.2.11.12-.03.06,0,.36-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.38,1.55s-.04.01-.07.02c.03,0,.05-.02.07-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "195.9 5.94 195.81 6 195.96 5.93 195.9 5.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M196.26,5.83l-.3.13.28-.1s-.04,0,.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.58,2.36l-.07.03c-.08.04-.08.04-.09.06l.16-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "birth-2",
    points: "197.47 2.7 197.47 2.7 197.21 2.82 197.47 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "birth-2",
    d: "M197.9,2.76s-.06,0-.05-.01c.06,0-.29.16.05.01Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirth);
export default __webpack_public_path__ + "static/media/Birth.60316c9d59bd1394a9f0e1f0adac142d.svg";
export { ForwardRef as ReactComponent };